import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import Polyline from 'react-google-maps/lib/components/Polyline';
import DirectionsRenderer from 'react-google-maps/lib/components/DirectionsRenderer';
import { Button, CircularProgress, Grid, IconButton, MenuItem, Select, Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab, LinearProgress } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { decimatePoints, getKeyStops, estimateMemoryUsage } from './mapOptimizations';



import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import DirectionsResult = google.maps.DirectionsResult;
import DirectionsLeg = google.maps.DirectionsLeg;
import DirectionsRoute = google.maps.DirectionsRoute;
import LatLngBounds = google.maps.LatLngBounds;
import { ConfigData } from "../../config";
import { BranchData } from '../BranchSelector'


import { Client, Driver, Race, Ruta, RutasData, Vehicle as ApiVehicle, VehicleType, RaceSchedule, Planning, Routing } from "src/api/model";
import { RaceActions } from "src/store/race/race-actions";

import { format } from "date-fns";

// import routesDataJSON from './routes_data.json';

export interface Vehicle {
    id: number;
    placa: string;
    marca: string;
    modelo: string;
    capacidadCajas: number;
    conductor?: Driver;
    estado: 'ACTIVO' | 'INACTIVO' | 'MANTENIMIENTO';
}

// Interfaces para la nueva estructura JSON multi-día
export interface StopData {
    secuenciaParada: number;
    tipoParada: string; // "Depósito (Salida)", "Cliente", "Depósito (Llegada)"
    nodoId: number;
    nombreSucursal: string;
    coordenadas_lon_lat: [number, number];
    coordenadas_lat_lon: [number, number];
    dia: number;
    horaLlegada: string;
    horaSalida: string;
    ventanaTiempo: string;
    volumenAEntregarM3: number;
    cajasAEntregar: number;
    volumenAdicionalM3: number;
    volumenAEntregarTotalM3: number;
    descarga_acumulada: number;
    distancia_desde_nodo_anterior_km: number;
    distancia_acumulada_km: number;
    tiempo_desde_nodo_anterior_min: number;
    tiempo_acumulado_dia_min: number;
    tiempo_acumulado_total_min: number;
}

export interface DayRoute {
    dia: number;
    paradas: StopData[];
}

export interface MultidayVehicleRoute {
    vehiculo_id: number;
    matricula: string;
    dias: DayRoute[];
}

export interface MultidayConfiguration {
    tiempo_trabajo_dia_minutos: number;
    deposito_indice: number;
    tiempo_de_servicio: number;
    tolerancia_horas_extras: number;
    hora_inicio_jornada_HH_mm: string;
    unidad_demanda: string;
    unidad_capacidad: string;
    volumen_caja_m3: number;
}

export interface MultidayRoutesData {
    modo: string;
    configuracion: MultidayConfiguration;
    rutas: MultidayVehicleRoute[];
    resumen: {
        cargaTotalPlanificacionCajas: number;
        cargaTotalPlanificacionVolumenM3: number;
        distanciaTotalPlanificacionKm: number;
        total_excluidos: number;
        total_servidos: number;
        total_sucursales: number;
        total_vehiculos_utilizados: number;
        max_cantidad_dias: number;
    }
    nodos_excluidos?: any;
}

export class Dot {
    lat: number;
    lng: number;

    constructor(latitude: number, longitude: number) {
        this.lat = latitude;
        this.lng = longitude;
    }

}

export interface RouteData {

    origin?: Dot;
    originStreet?: string;
    destiny?: Dot;
    destinyStreet?: string;

    distance?: number;
    price?: number;
    duration?: string;
    fullData?: DirectionsResult;
    route?: DirectionsRoute;
    leg?: DirectionsLeg;
    searchBounds?: LatLngBounds;

    // Client document
    clientDocument?: string;
    clientLocations?: LocationData[];
    selectedClientLocationId?: string;
    selectedClientLocation?: any;

    // Branch data used as origin 
    selectedBranch?: BranchData;
    branchList?: BranchData[];
    races?: Race[]
    branches?: any[]
    selectedDriver?: any;
    drivers?: Driver[];
    selectedType?: string;

    visitsDetail?: any[];
    selectedClient?: Client | undefined;
    selectedLoc?: any;
    items?: any[];
    observation?: string;
}

export interface PlanificacionSelectorProps {
    data?: RouteData;
    config: ConfigData;
    onNewData: (data: RouteData) => void;
    sendData: (data: any) => void;
    notification?: any;
    onCreateBranches?: (branches: any[]) => Promise<void>; // Callback para crear sucursales
    onCreateDrivers?: (drivers: any[]) => Promise<void>; // Callback para crear choferes
    onCancelBranchCreation?: () => void; // Callback para cancelar creación de sucursales
    driverActions?: { actions: any; notification: any }; // Actions para drivers
}

interface PlanificacionSelectorState {

    data: RouteData;
    line?: string;
    center: Dot;

    // new design clien data
    locations?: any[];
    isDialogOpenLoc: boolean;
    isDialogOpenReparto: boolean;
    isDialogOpen: boolean;
    isDialogHojaOpen: boolean;
    openSearch: boolean;
    actions: RaceActions;
    selectedValue: string,

    confirmarOrdenFlag: boolean;
    visitsDetail: any[];
    setPrice: number;
    limit: number;

    branchDestinyId: number;

    // Form state for CSV upload
    vehicleCapacityBoxes: string;
    numVehicles: string;
    horarioInicioJornada: string;
    depotIndex: number;
    serviceTime: number;
    demandUnit: string;
    capacityUnit: string;
    boxVolumeM3: number;
    csvLocationsFile: File | null;
    csvDriversFile: File | null;
    csvFleetFile: File | null;
    isUploading: boolean;
    selectedBranches: number[];
    selectedDrivers: number[];
    branchDemands: { [branchId: number]: number }; // Demandas personalizadas por sucursal
    driverCapacities: { [driverId: number]: number }; // Capacidades personalizadas por conductor
    matriculaToDriverId: { [matricula: string]: number }; // Mapeo de matrícula a ID de driver desde CSV
    vehicleIndexToDriverId: { [vehicleIndex: number]: number }; // Mapeo de índice de vehículo (vehiculo_id del WebService) a ID de driver real

    // Progress tracking for race creation
    isCreatingRaces: boolean;
    racesCreationProgress: number;
    totalRacesToCreate: number;
    racesCreated: number;

    // Progress tracking for branch creation from CSV
    isCreatingBranches: boolean;
    branchesCreationProgress: number;
    totalBranchesToCreate: number;
    branchesCreated: number;
    currentBatch: number;
    totalBatches: number;
    isCancellingBranches: boolean;
    retryAttempts: number;
    maxRetries: number;
    creationSummary: { success: number; errors: number; retries: number } | null;

    // Progress tracking for driver creation from CSV
    isCreatingDrivers: boolean;
    driversCreationProgress: number;
    totalDriversToCreate: number;
    driversCreated: number;
    currentDriverBatch: number;
    totalDriverBatches: number;
    isCancellingDrivers: boolean;
    driverRetryAttempts: number;
    driverMaxRetries: number;
    driverCreationSummary: { success: number; errors: number; retries: number } | null;

    // Routes data
    routesData: RutasData;
    selectedRouteId: number | null;
    showRoutesOnMap: boolean;
    routeDirections: { [key: string]: any };
    showMarkersOnly: boolean; // Solo mostrar marcadores sin rutas completas
    maxVisibleRoutes?: number;

    // Pending route calculations to avoid setState during render
    pendingRouteCalculations: string[]; // Array of route IDs that need calculation

    // Multiday routes data
    multidayRoutesData: MultidayRoutesData | null;
    selectedDay: number | null; // null = mostrar todos los días
    availableDays: number[]; // Array de días disponibles [1, 2, 3, ...]
    selectedVehicles: number[]; // Array de vehiculo_id seleccionados para mostrar

    // Excluded nodes data
    excludedNodes: any[];

    // Alert state for too many stops
    showTooManyStopsAlert: boolean; // Mostrar/ocultar alerta de demasiadas paradas
    isCalculatingRoutes: boolean; // Mostrar spinner mientras se calculan rutas

    // Planning date
    planningStartDate: string; // Fecha de inicio de la planificación en formato YYYY-MM-DD
    excludedNodesExpanded: boolean;
    // Modal state for route details
    showRouteDetailsModal: boolean;
    selectedRouteForDetails: Ruta | null;

    // Tab state
    selectedTab: number;

    totalCapacityFromFleetCSV: number;
    totalDemandFromLocationsCSV: number;
    locationsCSVLoaded: boolean;
    fleetCSVLoaded: boolean;
    dailyWorkMinutes: number;
    workTimeToleranceMinutes: number;
    maxDiasConsecutivos: number;
    diasLaborales: {
        domingo: boolean;
        lunes: boolean;
        martes: boolean;
        miercoles: boolean;
        jueves: boolean;
        viernes: boolean;
        sabado: boolean;
    };
    min_travel_time_for_rest_minutes: number;
}

interface MapProps {

    zoom: number;
    center: Dot;
    origin?: Dot;
    destiny?: any;
    directions: any;

    // Routes data
    routesData: RutasData;
    selectedRouteId?: number | null;
    showRoutesOnMap?: boolean;
    routeDirections: { [key: string]: any };
    onRouteDirectionsChange: (newRouteDirections: { [key: string]: any }) => void;
    maxVisibleRoutes?: number;
    showMarkersOnly?: boolean;

    // Multiday routes data
    multidayRoutesData?: MultidayRoutesData | null;
    selectedDay?: number | null;
    selectedVehicles?: number[];

}

export interface LocationData {
    id: number;
    lat: number;
    lng: number;

    street1: string;
    client: {
        user: { name: string, email: string }
        phone: string;

    };

}

// Variable para controlar las solicitudes en progreso a la API de Directions
let directionsRequestsInProgress = 0;
const MAX_CONCURRENT_DIRECTIONS_REQUESTS = 3; // REDUCIDO para evitar colapso de memoria

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
    const { center, zoom, directions, routesData, selectedRouteId, showRoutesOnMap, routeDirections, onRouteDirectionsChange, showMarkersOnly = false, multidayRoutesData, selectedDay, selectedVehicles } = props;

    // Optimización: calcular nivel de decimación según zoom - REDUCIDO PARA EVITAR COLAPSO
    const decimationFactor = zoom < 8 ? 3 : 1; // Solo decimar en zoom MUY bajo
    const shouldShowKeyPointsOnly = zoom < 7; // Solo en zoom extremadamente bajo

    // Límite de marcadores AUMENTADO para evitar recalculos constantes
    const MAX_MARKERS_PER_ROUTE = shouldShowKeyPointsOnly ? 20 : 200;

    // Función para obtener el color de cada ruta (mismo color para marcadores y polyline)
    const getRouteColor = (vehiculoId: number): string => {
        const colors = [
            // Primera fila - Colores primarios y básicos
            '#FF0000', // 1. Rojo
            '#00FF00', // 2. Verde lima
            '#0000FF', // 3. Azul
            '#FFFF00', // 4. Amarillo
            '#FF00FF', // 5. Magenta
            '#00FFFF', // 6. Cyan
            '#FF8000', // 7. Naranja
            '#8000FF', // 8. Púrpura
            '#00FF80', // 9. Verde menta
            '#FF0080', // 10. Rosa

            // Segunda fila - Colores complementarios y variaciones
            '#FF4500', // 11. Rojo-naranja (OrangeRed)
            '#32CD32', // 12. Verde lima (LimeGreen)
            '#4169E1', // 13. Azul real (RoyalBlue)
            '#FFD700', // 14. Oro (Gold)
            '#DC143C', // 15. Carmesí (Crimson)
            '#00CED1', // 16. Turquesa oscuro (DarkTurquoise)
            '#FF1493', // 17. Rosa intenso (DeepPink)
            '#9370DB', // 18. Púrpura medio (MediumPurple)
            '#20B2AA', // 19. Verde mar claro (LightSeaGreen)
            '#FF6347', // 20. Tomate (Tomato)
        ];
        return colors[(vehiculoId - 1) % colors.length];
    };

    // LÍMITE DE SEGURIDAD: Calcular total de paradas CONSIDERANDO FILTROS actuales
    let totalStops = 0;
    if (multidayRoutesData && multidayRoutesData.rutas) {
        totalStops = multidayRoutesData.rutas.reduce((total, vehicleRoute) => {
            // Filtrar por vehículos seleccionados
            if (selectedVehicles && selectedVehicles.length > 0 && !selectedVehicles.includes(vehicleRoute.vehiculo_id)) {
                return total;
            }

            if (vehicleRoute.dias) {
                return total + vehicleRoute.dias.reduce((dayTotal, dayRoute) => {
                    // Filtrar por día seleccionado
                    if (selectedDay && dayRoute.dia !== selectedDay) {
                        return dayTotal;
                    }

                    const paradasLength = dayRoute.paradas ? dayRoute.paradas.length : 0;
                    return dayTotal + paradasLength;
                }, 0);
            }
            return total;
        }, 0);
    } else if (routesData) {
        totalStops = routesData.reduce((total, route) => {
            const paradasLength = route.paradas ? route.paradas.length : 0;
            return total + paradasLength;
        }, 0);
    }

    // Si hay entre 501-1000 paradas (después de filtros), mostrar SOLO marcadores (sin rutas/líneas)
    const effectiveShowMarkersOnly = showMarkersOnly || (totalStops > 500 && totalStops <= 1000);

    if (totalStops > 500 && totalStops <= 1000 && !showMarkersOnly) {
        console.warn(`⚠️ ${totalStops} paradas detectadas después de filtros. Renderizando SOLO marcadores (sin rutas dibujadas) para mejor rendimiento.`);
    }

    // Si hay MÁS de 1000 paradas, simplemente mostrar un mapa vacío
    // La alerta se mostrará fuera del mapa desde el componente padre
    if (totalStops > 1000) {
        return (
            <GoogleMap defaultZoom={zoom} center={center}>
            </GoogleMap>
        );
    }

    return (
        <GoogleMap defaultZoom={zoom} center={center} >
            {/* Routes markers and directions */}
            {routesData && routesData.map((route: Ruta, routeIndex: number) => {
                // Filtrar por ruta seleccionada si existe
                if (selectedRouteId && route.vehiculoId !== selectedRouteId) { return null; };

                // Optimización: solo aplicar si zoom MUY bajo para evitar colapso
                let paradasAMostrar = route.paradas;

                if (shouldShowKeyPointsOnly && route.paradas.length > 30) {
                    // Solo en zoom < 7 Y si hay muchas paradas
                    paradasAMostrar = getKeyStops(route.paradas, 15);
                } else if (decimationFactor > 1 && route.paradas.length > 50) {
                    // Solo decimar si zoom < 8 Y muchas paradas
                    paradasAMostrar = decimatePoints(route.paradas, decimationFactor);
                }

                // Limitar cantidad final - límite ALTO
                const paradasLimitadas = paradasAMostrar.slice(0, MAX_MARKERS_PER_ROUTE);
                const paradasOcultas = route.paradas.length - paradasLimitadas.length;

                // Obtener color único para esta ruta
                const routeColor = getRouteColor(route.vehiculoId);

                return (
                    <React.Fragment key={route.vehiculoId}>
                        {/* Route markers */}
                        {paradasLimitadas.map((parada: any, index: number) => {
                            const isDepot = parada.tipoParada.includes('Depósito');
                            const isDescanso = parada.tipoParada === 'Descanso';

                            return (
                                <Marker
                                    key={`${route.vehiculoId}-${index}`}
                                    position={{ lat: parada.coordenadas[1], lng: parada.coordenadas[0] }}
                                    icon={{
                                        path: google.maps.SymbolPath.CIRCLE,
                                        scale: isDepot ? 12 : (isDescanso ? 11 : 10),
                                        fillColor: isDepot ? '#FFD700' : (isDescanso ? '#9370DB' : routeColor), // Dorado para depósitos, Púrpura para descansos
                                        fillOpacity: isDepot || isDescanso ? 1.0 : 0.9,
                                        strokeColor: '#FFFFFF',
                                        strokeWeight: 2,
                                    }}
                                    label={{
                                        text: isDepot ? '🏁' : (isDescanso ? 'D' : `${index}`),
                                        color: 'white',
                                        fontSize: isDepot ? '20px' : (isDescanso ? '16px' : '14px'),
                                        fontWeight: 'bold'
                                    }}
                                    title={`${parada.nombreSucursal} - ${parada.horaLlegada}${paradasOcultas > 0 && index === paradasLimitadas.length - 1 ? ` (+${paradasOcultas} más)` : ''}`}
                                />
                            );
                        })}

                        {/* Route directions - using Google Maps API directly */}
                        {!effectiveShowMarkersOnly && showRoutesOnMap && (() => {
                            // Only calculate if we don't have directions for this route yet
                            if (!routeDirections || !routeDirections.hasOwnProperty(route.vehiculoId)) {
                                // Capture route data immediately to avoid closure issues
                                const currentVehicleId = route.vehiculoId;
                                const currentParadas = [...route.paradas]; // Create a copy to avoid reference issues

                                // Crear clave única para cache basada en las coordenadas
                                const cacheKey = `route_${currentVehicleId}_${currentParadas.map(p => `${p.coordenadas[0]}_${p.coordenadas[1]}`).join('_')}`;

                                // Intentar obtener de cache primero - SOLO si no existe en routeDirections
                                try {
                                    const cachedRoute = localStorage.getItem(cacheKey);
                                    if (cachedRoute) {
                                        const parsedCache = JSON.parse(cachedRoute);
                                        const newRouteDirections = { ...routeDirections };

                                        // Manejar formato antiguo (sin timestamp) y nuevo (con timestamp)
                                        if (parsedCache.timestamp && parsedCache.data) {
                                            newRouteDirections[currentVehicleId] = parsedCache.data;
                                        } else {
                                            newRouteDirections[currentVehicleId] = parsedCache;
                                        }

                                        // CRÍTICO: usar setTimeout para evitar setState durante render
                                        setTimeout(() => onRouteDirectionsChange(newRouteDirections), 0);
                                        return null; // Usar cache y salir
                                    }
                                } catch (e) {
                                    // Si falla el cache, continuar con la llamada a la API
                                    // console.warn('Error leyendo cache:', e);
                                }

                                // Verificar si ya hay demasiadas solicitudes en progreso (throttling)
                                if (directionsRequestsInProgress >= MAX_CONCURRENT_DIRECTIONS_REQUESTS) {
                                    return null; // Esperar a que se completen las solicitudes actuales
                                }

                                // Calculate route using Google Maps Directions API
                                directionsRequestsInProgress++;
                                console.info(`🔄 Ruta ${currentVehicleId}: Calculando desde Google Maps API (${directionsRequestsInProgress}/${MAX_CONCURRENT_DIRECTIONS_REQUESTS} en progreso)...`);
                                const directionsService = new google.maps.DirectionsService();

                                const waypoints = currentParadas.slice(1, -1).map((parada: any) => ({
                                    location: new google.maps.LatLng(parada.coordenadas[1], parada.coordenadas[0]),
                                    stopover: true
                                }));

                                const request = {
                                    origin: new google.maps.LatLng(currentParadas[0].coordenadas[1], currentParadas[0].coordenadas[0]),
                                    destination: new google.maps.LatLng(currentParadas[currentParadas.length - 1].coordenadas[1], currentParadas[currentParadas.length - 1].coordenadas[0]),
                                    waypoints: waypoints,
                                    travelMode: google.maps.TravelMode.DRIVING,
                                    optimizeWaypoints: false
                                };

                                directionsService.route(request, (result: any, status: any) => {
                                    directionsRequestsInProgress--; // Decrementar contador

                                    if (status === google.maps.DirectionsStatus.OK && result) {
                                        console.info(`✅ Ruta ${currentVehicleId}: Calculada exitosamente. Guardando en cache...`);
                                        const newRouteDirections = { ...(routeDirections || {}) };
                                        newRouteDirections[currentVehicleId] = result; // Use captured vehicleId
                                        onRouteDirectionsChange(newRouteDirections);

                                        // Guardar en cache para futuros usos con timestamp
                                        try {
                                            const cacheData = {
                                                timestamp: Date.now(),
                                                data: result
                                            };
                                            localStorage.setItem(cacheKey, JSON.stringify(cacheData));
                                        } catch (e) {
                                            // Si falla guardar en cache (localStorage lleno), intentar limpiar cache antiguo
                                            if (e.name === 'QuotaExceededError') {
                                                console.warn('localStorage lleno, limpiando cache antiguo...');
                                                clearOldRoutesCache(7); // Limpiar rutas de más de 7 días
                                                try {
                                                    // Intentar guardar nuevamente
                                                    const cacheData = {
                                                        timestamp: Date.now(),
                                                        data: result
                                                    };
                                                    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
                                                } catch (retryError) {
                                                    // Si aún falla, no hacer nada
                                                    console.warn('No se pudo guardar en cache después de limpiar');
                                                }
                                            }
                                        }
                                    } else {
                                        console.warn(`Error calculating route for vehicle ${currentVehicleId}:`, status);
                                    }
                                });
                            }

                            return null; // This is just to trigger the calculation
                        })()}

                        {/* Render directions for this route */}
                        {!effectiveShowMarkersOnly && showRoutesOnMap && routeDirections && routeDirections[route.vehiculoId] && (
                            <DirectionsRenderer
                                directions={routeDirections[route.vehiculoId]}
                                options={{
                                    suppressMarkers: true,
                                    suppressInfoWindows: true, // Reducir peso
                                    preserveViewport: true, // No cambiar zoom automáticamente
                                    polylineOptions: {
                                        strokeColor: routeColor, // Usar el mismo color que los marcadores
                                        strokeOpacity: 0.7, // Reducido para mejor rendimiento
                                        strokeWeight: 4, // Hacer la línea un poco más visible
                                    }
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}

            {directions && (
                <DirectionsRenderer
                    directions={directions}
                    defaultOptions={{
                        suppressMarkers: true,
                        suppressInfoWindows: true,
                        preserveViewport: true
                    }}
                />
            )}

            {/* Renderizado de rutas multiday */}
            {multidayRoutesData && multidayRoutesData.rutas.map((vehicleRoute) => {
                // Filtrar por vehículos seleccionados
                if (selectedVehicles && selectedVehicles.length > 0 && !selectedVehicles.includes(vehicleRoute.vehiculo_id)) {
                    return null;
                }

                const routeColor = getRouteColor(vehicleRoute.vehiculo_id);

                return vehicleRoute.dias.map((dayRoute) => {
                    // Filtrar por día seleccionado
                    if (selectedDay !== null && dayRoute.dia !== selectedDay) {
                        return null;
                    }

                    // Optimización: solo aplicar si zoom MUY bajo
                    let paradasDelDia = dayRoute.paradas;

                    if (shouldShowKeyPointsOnly && dayRoute.paradas.length > 40) {
                        // Solo en zoom < 7 Y si hay MUCHAS paradas
                        paradasDelDia = getKeyStops(dayRoute.paradas, 20);
                    } else if (decimationFactor > 1 && dayRoute.paradas.length > 60) {
                        // Solo decimar si zoom < 8 Y muchas paradas
                        paradasDelDia = decimatePoints(dayRoute.paradas, decimationFactor);
                    }

                    return (
                        <React.Fragment key={`vehicle-${vehicleRoute.vehiculo_id}-day-${dayRoute.dia}`}>
                            {/* Renderizar marcadores para cada parada */}
                            {paradasDelDia.map((parada, index) => {
                                const isDepot = parada.tipoParada.includes('Depósito');
                                const isDescanso = parada.tipoParada === 'Descanso';
                                const lat = parada.coordenadas_lat_lon[0];
                                const lng = parada.coordenadas_lat_lon[1];

                                return (
                                    <Marker
                                        key={`${vehicleRoute.vehiculo_id}-${dayRoute.dia}-${index}`}
                                        position={{ lat, lng }}
                                        icon={{
                                            path: google.maps.SymbolPath.CIRCLE,
                                            scale: isDepot ? 12 : (isDescanso ? 10 : 8),
                                            fillColor: isDepot ? '#FFD700' : (isDescanso ? '#9370DB' : routeColor),
                                            fillOpacity: isDepot || isDescanso ? 1.0 : 0.8,
                                            strokeColor: '#FFFFFF',
                                            strokeWeight: 2,
                                        }}
                                        label={{
                                            text: isDepot ? (parada.tipoParada.includes('Salida') ? '🚀' : '🏁') : (isDescanso ? 'D' : `${parada.secuenciaParada}`),
                                            color: 'white',
                                            fontSize: isDepot ? '16px' : (isDescanso ? '14px' : '12px'),
                                            fontWeight: 'bold'
                                        }}
                                        title={isDescanso 
                                            ? `${parada.nombreSucursal}\nDía ${dayRoute.dia} - Vehículo ${vehicleRoute.matricula}\nLlegada: ${parada.horaLlegada} | Salida: ${parada.horaSalida}\n⏸️ PUNTO DE DESCANSO`
                                            : `${parada.nombreSucursal}\nDía ${dayRoute.dia} - Vehículo ${vehicleRoute.matricula}\nLlegada: ${parada.horaLlegada} | Salida: ${parada.horaSalida}\nCajas: ${parada.cajasAEntregar}`}
                                    />
                                );
                            })}

                            {/* Calcular y renderizar rutas reales con Google Directions API - SOLO PARA EL DÍA SELECCIONADO Y ZOOM SUFICIENTE */}
                            {!effectiveShowMarkersOnly && showRoutesOnMap && zoom >= 12 && dayRoute.paradas.length > 1 && selectedDay && dayRoute.dia === selectedDay && (() => {
                                // Crear ID único para esta ruta multiday
                                const multidayRouteId = `multiday_${vehicleRoute.vehiculo_id}_day_${dayRoute.dia}`;

                                // Verificar si ya tenemos direcciones calculadas para esta ruta
                                if (!routeDirections || !routeDirections.hasOwnProperty(multidayRouteId)) {

                                    // Verificar límite de solicitudes concurrentes
                                    if (directionsRequestsInProgress >= MAX_CONCURRENT_DIRECTIONS_REQUESTS) {
                                        return null;
                                    }

                                    // Calcular ruta con Google Directions API
                                    directionsRequestsInProgress++;
                                    // console.info(`🔄 Ruta multiday ${multidayRouteId}: Calculando desde Google Maps API...`);
                                    const directionsService = new google.maps.DirectionsService();

                                    const waypoints = dayRoute.paradas.slice(1, -1).map((parada: any) => ({
                                        location: new google.maps.LatLng(parada.coordenadas_lat_lon[0], parada.coordenadas_lat_lon[1]),
                                        stopover: true
                                    }));

                                    // Google Maps tiene límite de 25 waypoints por solicitud
                                    const MAX_WAYPOINTS = 25;
                                    if (waypoints.length > MAX_WAYPOINTS) {
                                        console.info(`📊 Ruta ${multidayRouteId} tiene ${waypoints.length} waypoints, dividiendo en segmentos...`);

                                        // Dividir waypoints en segmentos de máximo 25
                                        const segments: any[][] = [];
                                        for (let i = 0; i < waypoints.length; i += MAX_WAYPOINTS) {
                                            segments.push(waypoints.slice(i, i + MAX_WAYPOINTS));
                                        }

                                        // Calcular cada segmento
                                        const segmentPromises = segments.map((segmentWaypoints, segmentIndex) => {
                                            return new Promise((resolve, reject) => {
                                                const segmentRequest = {
                                                    origin: segmentIndex === 0
                                                        ? new google.maps.LatLng(
                                                            dayRoute.paradas[0].coordenadas_lat_lon[0],
                                                            dayRoute.paradas[0].coordenadas_lat_lon[1]
                                                        )
                                                        : segments[segmentIndex - 1][segments[segmentIndex - 1].length - 1].location,
                                                    destination: segmentIndex === segments.length - 1
                                                        ? new google.maps.LatLng(
                                                            dayRoute.paradas[dayRoute.paradas.length - 1].coordenadas_lat_lon[0],
                                                            dayRoute.paradas[dayRoute.paradas.length - 1].coordenadas_lat_lon[1]
                                                        )
                                                        : segmentWaypoints[segmentWaypoints.length - 1].location,
                                                    waypoints: segmentIndex === 0 && segmentIndex === segments.length - 1
                                                        ? segmentWaypoints
                                                        : segmentIndex === 0
                                                            ? segmentWaypoints.slice(0, -1) // No incluir último como waypoint si no es el último segmento
                                                            : segmentIndex === segments.length - 1
                                                                ? segmentWaypoints.slice(1) // No incluir primero como waypoint si no es el primer segmento
                                                                : segmentWaypoints.slice(1, -1), // No incluir primero ni último como waypoints
                                                    travelMode: google.maps.TravelMode.DRIVING,
                                                    optimizeWaypoints: false
                                                };

                                                directionsService.route(segmentRequest, (result: any, status: any) => {
                                                    if (status === google.maps.DirectionsStatus.OK && result) {
                                                        resolve(result);
                                                    } else {
                                                        reject(new Error(`Error en segmento ${segmentIndex}: ${status}`));
                                                    }
                                                });
                                            });
                                        });

                                        // Esperar a que todos los segmentos se calculen
                                        Promise.all(segmentPromises).then((segmentResults: any[]) => {
                                            directionsRequestsInProgress--;

                                            // Combinar todos los segmentos en una sola ruta
                                            const combinedResult = {
                                                ...segmentResults[0],
                                                routes: [{
                                                    ...segmentResults[0].routes[0],
                                                    legs: segmentResults.reduce((allLegs: any[], result: any) => allLegs.concat(result.routes[0].legs), []),
                                                    overview_path: segmentResults.reduce((allPaths: any[], result: any) =>
                                                        allPaths.concat(result.routes[0].overview_path || []), []),
                                                    bounds: segmentResults.reduce((bounds: any, result: any) => {
                                                        if (bounds && result.routes[0].bounds) {
                                                            bounds.union(result.routes[0].bounds);
                                                        } else if (result.routes[0].bounds) {
                                                            return result.routes[0].bounds;
                                                        }
                                                        return bounds;
                                                    }, null)
                                                }]
                                            };

                                            // console.info(`✅ Ruta multiday ${multidayRouteId}: ${segments.length} segmentos combinados exitosamente`);
                                            const newRouteDirections = { ...(routeDirections || {}) };
                                            newRouteDirections[multidayRouteId] = combinedResult;
                                            onRouteDirectionsChange(newRouteDirections);
                                        }).catch((error) => {
                                            directionsRequestsInProgress--;
                                            console.warn(`Error calculando segmentos para ruta multiday ${multidayRouteId}:`, error);
                                        });

                                    } else {
                                        // Ruta normal con <= 25 waypoints
                                        const request = {
                                            origin: new google.maps.LatLng(
                                                dayRoute.paradas[0].coordenadas_lat_lon[0],
                                                dayRoute.paradas[0].coordenadas_lat_lon[1]
                                            ),
                                            destination: new google.maps.LatLng(
                                                dayRoute.paradas[dayRoute.paradas.length - 1].coordenadas_lat_lon[0],
                                                dayRoute.paradas[dayRoute.paradas.length - 1].coordenadas_lat_lon[1]
                                            ),
                                            waypoints: waypoints,
                                            travelMode: google.maps.TravelMode.DRIVING,
                                            optimizeWaypoints: false
                                        };

                                        directionsService.route(request, (result: any, status: any) => {
                                            directionsRequestsInProgress--;

                                            if (status === google.maps.DirectionsStatus.OK && result) {
                                                console.info(`✅ Ruta multiday ${multidayRouteId}: Calculada exitosamente`);
                                                const newRouteDirections = { ...(routeDirections || {}) };
                                                newRouteDirections[multidayRouteId] = result;
                                                onRouteDirectionsChange(newRouteDirections);
                                            } else {
                                                console.warn(`Error calculando ruta multiday ${multidayRouteId}:`, status);
                                            }
                                        });
                                    }
                                }

                                return null;
                            })()}

                            {/* Renderizar direcciones calculadas para el día seleccionado */}
                            {!effectiveShowMarkersOnly && showRoutesOnMap && selectedDay && dayRoute.dia === selectedDay && routeDirections && routeDirections[`multiday_${vehicleRoute.vehiculo_id}_day_${dayRoute.dia}`] && (
                                <DirectionsRenderer
                                    directions={routeDirections[`multiday_${vehicleRoute.vehiculo_id}_day_${dayRoute.dia}`]}
                                    options={{
                                        suppressMarkers: true,
                                        suppressInfoWindows: true,
                                        preserveViewport: true,
                                        polylineOptions: {
                                            strokeColor: routeColor,
                                            strokeOpacity: 0.7,
                                            strokeWeight: 4,
                                        }
                                    }}
                                />
                            )}

                            {/* Renderizar líneas simples para días NO seleccionados (más rápido) */}
                            {!effectiveShowMarkersOnly && showRoutesOnMap && dayRoute.paradas.length > 1 && (!selectedDay || dayRoute.dia !== selectedDay) && (
                                <Polyline
                                    path={dayRoute.paradas.map((parada: any) => ({
                                        lat: parada.coordenadas_lat_lon[0],
                                        lng: parada.coordenadas_lat_lon[1]
                                    }))}
                                    options={{
                                        strokeColor: routeColor,
                                        strokeOpacity: 0.4,
                                        strokeWeight: 2,
                                        geodesic: true
                                    }}
                                />
                            )}
                        </React.Fragment>
                    );
                });
            })}
        </GoogleMap>
    );
};

// Función utilitaria para limpiar cache de rutas antiguas (puede ser llamada manualmente)
export const clearRoutesCache = () => {
    try {
        const keys = Object.keys(localStorage);
        let count = 0;
        keys.forEach(key => {
            if (key.startsWith('route_')) {
                localStorage.removeItem(key);
                count++;
            }
        });
        console.info(`Cache de rutas limpiado correctamente. ${count} rutas eliminadas.`);
        return { success: true, count };
    } catch (e) {
        console.error('Error limpiando cache de rutas:', e);
        return { success: false, count: 0 };
    }
};

// Función para obtener información del cache
export const getRoutesCacheInfo = () => {
    try {
        const keys = Object.keys(localStorage);
        const routeKeys = keys.filter(key => key.startsWith('route_'));

        let totalSize = 0;
        routeKeys.forEach(key => {
            const item = localStorage.getItem(key);
            if (item) {
                // Calcular tamaño aproximado en bytes
                totalSize += new Blob([item]).size;
            }
        });

        // Convertir a KB o MB
        const sizeKB = (totalSize / 1024).toFixed(2);
        const sizeMB = (totalSize / (1024 * 1024)).toFixed(2);

        return {
            routeCount: routeKeys.length,
            totalSizeBytes: totalSize,
            totalSizeKB: parseFloat(sizeKB),
            totalSizeMB: parseFloat(sizeMB),
            maxStorage: '5-10 MB (típico)', // localStorage típicamente tiene 5-10MB
        };
    } catch (e) {
        console.error('Error obteniendo información del cache:', e);
        return null;
    }
};

// Función para limpiar cache antiguo (más de X días)
export const clearOldRoutesCache = (daysOld: number = 7) => {
    try {
        const keys = Object.keys(localStorage);
        const now = Date.now();
        const maxAge = daysOld * 24 * 60 * 60 * 1000; // Convertir días a milisegundos

        let count = 0;
        keys.forEach(key => {
            if (key.startsWith('route_')) {
                try {
                    const item = localStorage.getItem(key);
                    if (item) {
                        const data = JSON.parse(item);
                        // Si tiene timestamp y es muy viejo, eliminarlo
                        if (data.timestamp && (now - data.timestamp > maxAge)) {
                            localStorage.removeItem(key);
                            count++;
                        }
                    }
                } catch (parseError) {
                    // Si no se puede parsear, eliminar (corrupto)
                    localStorage.removeItem(key);
                    count++;
                }
            }
        });

        console.info(`Cache antiguo limpiado. ${count} rutas eliminadas (más de ${daysOld} días).`);
        return { success: true, count };
    } catch (e) {
        console.error('Error limpiando cache antiguo:', e);
        return { success: false, count: 0 };
    }
};

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(RouteMap);

class PlanificacionMultiSelector extends React.Component<PlanificacionSelectorProps, PlanificacionSelectorState> {

    refOrigin: StandaloneSearchBox;
    refDestiny: StandaloneSearchBox;

    constructor(props: PlanificacionSelectorProps) {
        super(props);
        this.state = {
            data: {
                originStreet: props.config.races.predefinedFrom ? 'Origen' : '',
                destinyStreet: '',
                clientDocument: '',
                clientLocations: [],
                selectedDriver: null,
                drivers: [],
                selectedType: '',
                items: [
                    { id: 'item-1', content: 'Item 1' },
                    { id: 'item-2', content: 'Item 2' },
                    { id: 'item-3', content: 'Item 3' },
                ],
                branchList: props.data && props.data.branchList ? props.data.branchList : [],
                ...props.data,
            },
            center: props.config.maps.startingLocation,

            locations: [],
            isDialogOpenLoc: false,
            isDialogOpenReparto: false,
            isDialogOpen: false,
            isDialogHojaOpen: false,
            openSearch: false,
            actions: new RaceActions(),
            selectedValue: 'REMISION',
            confirmarOrdenFlag: false,
            visitsDetail: [],
            setPrice: 0,
            limit: 200,
            branchDestinyId: 0,

            // Form state for CSV upload
            vehicleCapacityBoxes: '',
            numVehicles: '',
            depotIndex: 0,
            serviceTime: 8,
            demandUnit: 'cajas',
            capacityUnit: 'cajas',
            boxVolumeM3: 0.052,
            csvLocationsFile: null,
            csvDriversFile: null,
            csvFleetFile: null,
            isUploading: false,
            horarioInicioJornada: '06:00',

            // Routes data
            routesData: [],
            selectedRouteId: null,
            showRoutesOnMap: false,
            routeDirections: {},
            showMarkersOnly: true, // Por defecto solo mostrar marcadores
            maxVisibleRoutes: 999, // Sin límite - todas las rutas visibles

            // Pending route calculations to avoid setState during render
            pendingRouteCalculations: [],

            // Multiday routes data
            multidayRoutesData: null,
            selectedDay: null, // null = mostrar todos los días
            availableDays: [],
            selectedVehicles: [],

            // Excluded nodes data
            excludedNodes: [],
            excludedNodesExpanded: false,

            // Alert state
            showTooManyStopsAlert: true, // Por defecto mostrar la alerta si hay muchas paradas
            isCalculatingRoutes: false, // No hay rutas siendo calculadas al inicio

            // Modal state for route details
            showRouteDetailsModal: false,
            selectedRouteForDetails: null,
            selectedBranches: [],
            selectedDrivers: [],
            branchDemands: {}, // Para almacenar las demandas personalizadas de cada sucursal
            driverCapacities: {}, // Para almacenar las capacidades personalizadas de cada conductor
            matriculaToDriverId: {}, // Mapeo de matrícula a ID de driver desde CSV
            vehicleIndexToDriverId: {}, // Mapeo de índice de vehículo (vehiculo_id del WebService) a ID de driver real

            // CSV Summary tracking
            totalDemandFromLocationsCSV: 0, // Suma total de cajas de ubicaciones CSV
            totalCapacityFromFleetCSV: 0, // Suma total de capacidad de vehículos CSV
            locationsCSVLoaded: false,
            fleetCSVLoaded: false,

            // Progress tracking for race creation
            isCreatingRaces: false,
            racesCreationProgress: 0,
            totalRacesToCreate: 0,
            racesCreated: 0,

            // Tab state
            selectedTab: 0, // 0 for CSV, 1 for System
            isCreatingBranches: false,
            branchesCreationProgress: 0,
            totalBranchesToCreate: 0,
            branchesCreated: 0,
            currentBatch: 0,
            totalBatches: 0,
            isCancellingBranches: false,
            retryAttempts: 0,
            maxRetries: 3,
            creationSummary: null,

            // Progress tracking for driver creation from CSV
            isCreatingDrivers: false,
            driversCreationProgress: 0,
            totalDriversToCreate: 0,
            driversCreated: 0,
            currentDriverBatch: 0,
            totalDriverBatches: 0,
            isCancellingDrivers: false,
            driverRetryAttempts: 0,
            driverMaxRetries: 3,
            driverCreationSummary: null,

            // Planning date
            planningStartDate: format(new Date(), "YYYY-MM-DD"),
            dailyWorkMinutes: 480, // 8 hours by default
            workTimeToleranceMinutes: 120, // 1 hour by default
            maxDiasConsecutivos: 5, // 5 days by default
            diasLaborales: {
                domingo: false,
                lunes: true,
                martes: true,
                miercoles: true,
                jueves: true,
                viernes: true,
                sabado: false
            },
            min_travel_time_for_rest_minutes: 120
        };

        this.onChangeBranchSelector = this.onChangeBranchSelector.bind(this);
        this.onChangeBranchSelectorMult = this.onChangeBranchSelectorMult.bind(this);
        this.onChangeDriverSelectorMult = this.onChangeDriverSelectorMult.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleFormSubmitFromSystem = this.handleFormSubmitFromSystem.bind(this);
        this.handleBranchDemandChange = this.handleBranchDemandChange.bind(this);
        this.handleDriverCapacityChange = this.handleDriverCapacityChange.bind(this);
        this.isCSVFormValid = this.isCSVFormValid.bind(this);
        this.isSystemFormValid = this.isSystemFormValid.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.parseMultidayJSON = this.parseMultidayJSON.bind(this);
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleVehicleSelection = this.handleVehicleSelection.bind(this);
        this.handleSelectAllVehicles = this.handleSelectAllVehicles.bind(this);
        this.handleHorarioInicioJornadaChange = this.handleHorarioInicioJornadaChange.bind(this);
        this.handleDailyWorkMinutesChange = this.handleDailyWorkMinutesChange.bind(this);
        this.handleWorkTimeToleranceChange = this.handleWorkTimeToleranceChange.bind(this);
        this.handleMaxDiasConsecutivosChange = this.handleMaxDiasConsecutivosChange.bind(this);
        this.handleMinTravelTimeForRestChange = this.handleMinTravelTimeForRestChange.bind(this);
    }

    componentDidMount() {
        // console.log('🚀 Auto-cargando JSON de prueba para desarrollo...');
        // fetch('/routes_data.json')
        //     .then(response => {
        //         if (!response.ok) {
        //             throw new Error(`HTTP error! status: ${response.status}`);
        //         }
        //         return response.json();
        //     })
        //     .then(jsonData => {
        //         this.parseMultidayJSON(jsonData as any);
        //         this.props.notification.notification.addInfo('JSON de prueba cargado automáticamente');
        //     })
        //     .catch(error => {
        //         console.error('❌ Error cargando JSON automáticamente:', error);
        //     });
    }

    componentDidUpdate(prevProps: PlanificacionSelectorProps, prevState: PlanificacionSelectorState) {
        if (prevProps.data !== this.props.data && this.props.data && this.props.data.branchList) {
            this.setState(state => ({
                data: {
                    ...state.data,
                    branchList: this.props.data!.branchList
                }
            }));
        }
        if (prevProps.data !== this.props.data && this.props.data && this.props.data.drivers) {
            console.log('Actualizando drivers en estado local:', this.props.data.drivers.length);
            this.setState(state => ({
                data: {
                    ...state.data,
                    drivers: this.props.data!.drivers
                }
            }));
        }

        // Si se han actualizado las direcciones de rutas y está calculando, dar un delay para apagar el spinner
        if (prevState && prevState.routeDirections !== this.state.routeDirections && this.state.isCalculatingRoutes) {
            // Esperar 2 segundos antes de apagar el spinner para asegurar que todas las rutas están calculadas
            setTimeout(() => {
                if (this.state.isCalculatingRoutes) {
                    this.setState({ isCalculatingRoutes: false });
                }
            }, 2000);
        }
    }












    onChangeBranchSelectorMult(e: React.ChangeEvent<{ value: unknown }>) {
        const selectedBranchIds = e.target.value as number[];

        // Inicializar demandas para las nuevas sucursales seleccionadas
        const newBranchDemands = { ...this.state.branchDemands };
        selectedBranchIds.forEach(branchId => {
            if (!newBranchDemands[branchId]) {
                newBranchDemands[branchId] = 10; // Valor por defecto
            }
        });

        // Remover demandas de sucursales deseleccionadas
        const deselectedBranches = this.state.selectedBranches.filter(id => !selectedBranchIds.includes(id));
        deselectedBranches.forEach(branchId => {
            delete newBranchDemands[branchId];
        });

        this.setState({
            selectedBranches: selectedBranchIds,
            branchDemands: newBranchDemands
        });
    }

    onChangeDriverSelectorMult(e: React.ChangeEvent<{ value: unknown }>) {
        const selectedDriverIds = e.target.value as number[];

        // Inicializar capacidades para los nuevos conductores seleccionados
        const newDriverCapacities = { ...this.state.driverCapacities };
        selectedDriverIds.forEach(driverId => {
            if (!newDriverCapacities[driverId]) {
                newDriverCapacities[driverId] = 50; // Valor por defecto
            }
        });

        // Remover capacidades de conductores deseleccionados
        const deselectedDrivers = this.state.selectedDrivers.filter(id => !selectedDriverIds.includes(id));
        deselectedDrivers.forEach(driverId => {
            delete newDriverCapacities[driverId];
        });

        this.setState({
            selectedDrivers: selectedDriverIds,
            driverCapacities: newDriverCapacities
        });
    }

    handleBranchDemandChange = (branchId: number, newDemand: number) => {
        this.setState(prevState => ({
            branchDemands: {
                ...prevState.branchDemands,
                [branchId]: newDemand
            }
        }));
    };

    handleDriverCapacityChange = (driverId: number, newCapacity: number) => {
        this.setState(prevState => ({
            driverCapacities: {
                ...prevState.driverCapacities,
                [driverId]: newCapacity
            }
        }));
    };

    isCSVFormValid = (): boolean => {
        return !!(
            this.state.csvLocationsFile &&
            this.state.csvFleetFile &&
            this.state.boxVolumeM3 > 0
        );
    };

    isSystemFormValid = (): boolean => {
        return !!(
            this.state.selectedBranches.length > 0 &&
            this.state.selectedDrivers.length > 0 &&
            this.state.boxVolumeM3 > 0.01
        );
    };

    handleReset = () => {
        this.setState({
            // Reset CSV form fields
            vehicleCapacityBoxes: '',
            numVehicles: '',
            depotIndex: 0,
            serviceTime: 10,
            demandUnit: 'cajas',
            capacityUnit: 'cajas',
            boxVolumeM3: 0.052,
            csvLocationsFile: null,
            csvFleetFile: null,
            csvDriversFile: null,
            isUploading: false,

            // Reset system form fields
            selectedBranches: [],
            selectedDrivers: [],
            branchDemands: {},
            driverCapacities: {},

            // Reset routes data
            routesData: [],
            selectedRouteId: null,
            showRoutesOnMap: false,
            routeDirections: {},

            // Reset excluded nodes
            excludedNodes: [],
            excludedNodesExpanded: false,

            // Reset modal state
            showRouteDetailsModal: false,
            selectedRouteForDetails: null,

            // Reset progress tracking
            isCreatingRaces: false,
            racesCreationProgress: 0,
            totalRacesToCreate: 0,
            racesCreated: 0,

            // Reset días laborales
            diasLaborales: {
                domingo: false,
                lunes: true,
                martes: true,
                miercoles: true,
                jueves: true,
                viernes: true,
                sabado: false
            }
        });

        // Show success notification
        this.props.notification.notification.addInfo('Formulario limpiado correctamente');
    };

    // Función para parsear el JSON multi-día
    parseMultidayJSON = (jsonData: MultidayRoutesData) => {
        try {
            // Limpiar residuos en localStorage antes de cargar nuevos datos
            this.cleanupLocalStorageResidues();

            // Extraer días únicos
            const daysSet = new Set<number>();
            jsonData.rutas.forEach(ruta => {
                ruta.dias.forEach(dia => {
                    daysSet.add(dia.dia);
                });
            });
            const availableDays = Array.from(daysSet).sort((a, b) => a - b);

            // Extraer vehículos
            const vehicleIds = jsonData.rutas.map(ruta => ruta.vehiculo_id);

            // Verificar uso de memoria estimado
            const memoryEstimate = estimateMemoryUsage(jsonData.rutas);
            // console.log(`📊 Memoria estimada: ${memoryEstimate.estimatedMB.toFixed(2)} MB, ${memoryEstimate.totalPoints} puntos totales`);

            // Mostrar warning si hay muchos puntos
            if (memoryEstimate.recommendedVirtualization) {
                this.props.notification.notification.addWarning(
                    'Gran cantidad de datos detectada',
                    `Se detectaron ${memoryEstimate.totalPoints} puntos (~${memoryEstimate.estimatedMB.toFixed(1)}MB). Recomendamos:\n- Seleccionar un día específico\n- Activar "Solo Marcadores"\n- Filtrar por vehículos específicos`
                );
            }

            this.setState({
                multidayRoutesData: jsonData,
                availableDays: availableDays,
                selectedVehicles: vehicleIds, // Por defecto todos los vehículos seleccionados
                selectedDay: null, // null = mostrar todos los días
                showRoutesOnMap: true, // Activar visualización en el mapa
                selectedRouteId: null, // Mostrar todas las rutas
                routesData: [], // Limpiar rutas single-day si las hubiera
                showMarkersOnly: memoryEstimate.recommendedVirtualization ? true : this.state.showMarkersOnly, // Activar modo marcadores si hay mucha data
                excludedNodes: jsonData.nodos_excluidos, // Cargar nodos excluidos si existen
                showTooManyStopsAlert: true, // Resetear alerta para que se muestre si es necesario
                isCalculatingRoutes: false // No iniciar cálculo hasta que el usuario lo solicite
            });

            this.props.notification.notification.addInfo(
                `JSON cargado: ${jsonData.rutas.length} vehículos, ${availableDays.length} días`
            );
        } catch (error) {
            console.error('Error parseando JSON multi-día:', error);
            this.props.notification.notification.addError('Error al procesar el archivo JSON');
        }
    };

    // Función para cambiar el día seleccionado
    handleDayChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const dayValue = event.target.value;
        this.setState({
            selectedDay: dayValue === 'all' ? null : Number(dayValue)
        });
    };

    // Función para cerrar la alerta de demasiadas paradas
    handleCloseTooManyStopsAlert = () => {
        this.setState({
            showTooManyStopsAlert: false
        });
    };

    // Función para seleccionar/deseleccionar vehículos
    handleVehicleSelection = (vehicleId: number) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedVehicles.includes(vehicleId);
            if (isSelected) {
                return {
                    selectedVehicles: prevState.selectedVehicles.filter(id => id !== vehicleId)
                };
            } else {
                return {
                    selectedVehicles: [...prevState.selectedVehicles, vehicleId]
                };
            }
        });
    };

    // Función para seleccionar todos los vehículos
    handleSelectAllVehicles = () => {
        if (this.state.multidayRoutesData && this.state.multidayRoutesData.rutas) {
            const allVehicleIds = this.state.multidayRoutesData.rutas.map(vehicleRoute => vehicleRoute.vehiculo_id);
            this.setState({
                selectedVehicles: allVehicleIds
            });
        }
    };

    // Función para obtener el color de un vehículo
    getVehicleColor = (vehicleId: number): string => {
        const colors = [
            '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF',
            '#00FFFF', '#FF8000', '#8000FF', '#00FF80', '#FF0080',
            '#FF4500', '#32CD32', '#4169E1', '#FFD700', '#DC143C',
            '#00CED1', '#FF1493', '#9370DB', '#20B2AA', '#FF6347'
        ];
        return colors[(vehicleId - 1) % colors.length];
    };

    // Función para limpiar residuos en localStorage
    cleanupLocalStorageResidues = () => {
        try {
            const keysToRemove: string[] = [];
            const now = Date.now();

            // Iterar sobre todas las claves en localStorage
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (!key) {
                    continue;
                }

                // Buscar y marcar para eliminar residuos de cache multiday antiguo
                if (key.startsWith('multiday_stops_cache_')) {
                    keysToRemove.push(key);
                    continue;
                }

                // Limpiar rutas en cache que sean más de 1 día
                if (key.startsWith('route_')) {
                    try {
                        const item = localStorage.getItem(key);
                        if (item) {
                            const parsed = JSON.parse(item);
                            const timestamp = parsed.timestamp || 0;
                            const ageMs = now - timestamp;
                            const oneDayMs = 24 * 60 * 60 * 1000;

                            // Si es más viejo que 1 día, marcarlo para eliminar
                            if (ageMs > oneDayMs) {
                                keysToRemove.push(key);
                            }
                        }
                    } catch (e) {
                        // Si no se puede parsear, eliminar
                        keysToRemove.push(key);
                    }
                }
            }

            // Eliminar todas las claves marcadas
            if (keysToRemove.length > 0) {
                keysToRemove.forEach(key => {
                    localStorage.removeItem(key);
                });
                console.info(`🧹 Limpieza de localStorage: ${keysToRemove.length} residuos eliminados`);
                console.log('Claves eliminadas:', keysToRemove);
            }
        } catch (error) {
            console.warn('Error durante la limpieza de localStorage:', error);
        }
    };

    // Función para crear la estructura Planning a partir de las rutas optimizadas
    createPlanningStructure = (routesData: any[], selectedDriversData: any[]): Planning => {
        // Usar estadísticas del resumen si está disponible (para multiday), sino calcular
        let totalKm = 0;
        let totalBoxes = 0;
        let totalVehicles = routesData.length;
        let totalDays = 1;

        // Si tenemos datos multiday, usar el resumen
        if (this.state.multidayRoutesData && this.state.multidayRoutesData.resumen) {
            totalKm = this.state.multidayRoutesData.resumen.distanciaTotalPlanificacionKm || 0;
            totalBoxes = this.state.multidayRoutesData.resumen.cargaTotalPlanificacionCajas || 0;
            totalVehicles = this.state.multidayRoutesData.resumen.total_vehiculos_utilizados || routesData.length;
            totalDays = this.state.multidayRoutesData.resumen.max_cantidad_dias || 1;
        }

        // Agrupar rutas por driver
        const routingsByDriver: { [driverId: string]: RaceSchedule[] } = {};

        routesData.forEach((route, routeIndex) => {
            // Acumular estadísticas solo para single-day (para multiday ya las tenemos del resumen)
            if (!this.state.multidayRoutesData) {
                totalKm += route.distanciaTotalPlanificacionKm || 0;
                totalBoxes += route.cargaTotalRutaCajas || 0;
            }

            // Determinar el driver para esta ruta - usar matrícula como clave principal
            console.log('🔍 Procesando ruta - vehiculo_id:', route.vehiculo_id, 'matricula:', route.matricula);

            let selectedDriver: Driver | undefined;

            // Primero intentar buscar por matrícula (registryNumber) directamente en los drivers
            if (route.matricula && this.state.data.drivers && this.state.data.drivers.length > 0) {
                const matriculaKey = route.matricula.toLowerCase().trim();
                console.log(`🔑 Buscando driver con registryNumber: "${matriculaKey}"`);

                selectedDriver = this.state.data.drivers.find(d =>
                    d.registryNumber !== undefined && d.registryNumber.toLowerCase().trim() === matriculaKey
                );

                if (selectedDriver) {
                    console.log('✅ Driver encontrado por registryNumber:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                } else {
                    console.warn(`⚠️ No hay driver con registryNumber "${matriculaKey}"`);
                    console.log(`📌 RegistryNumbers disponibles:`, this.state.data.drivers.map(d => `${d.registryNumber} (ID: ${d.id})`));
                }
            }

            // Si no se encontró por matrícula, intentar mapeo del CSV si existe
            if (!selectedDriver) {
                if (route.matricula) {
                    const matriculaKey = route.matricula.toLowerCase().trim();
                    const mappedDriverId = this.state.matriculaToDriverId[matriculaKey];
                    if (mappedDriverId) {
                        selectedDriver = this.state.data.drivers && this.state.data.drivers.find(d => d.id === mappedDriverId);
                        if (selectedDriver) {
                            console.log('✅ Driver encontrado por mapeo CSV:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                        }
                    }
                }
            }

            // Si no se encontró, intentar mapeo del índice del CSV
            if (!selectedDriver) {
                const mappedDriverId = this.state.vehicleIndexToDriverId[route.vehiculo_id];
                if (mappedDriverId) {
                    selectedDriver = this.state.data.drivers && this.state.data.drivers.find(d => d.id === mappedDriverId);
                    if (selectedDriver) {
                        console.log('✅ Driver encontrado por mapeo CSV índice:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                    }
                }
            }

            // Si no hay mapeo CSV o no se encontró, usar el índice directo de drivers del sistema
            if (!selectedDriver && this.state.data.drivers && this.state.data.drivers.length > 0) {
                const driverIndex = route.vehiculo_id - 1; // vehiculo_id es 1-based, array es 0-based
                if (driverIndex >= 0 && driverIndex < this.state.data.drivers.length) {
                    selectedDriver = this.state.data.drivers[driverIndex];
                    console.log('✅ Driver encontrado por índice del sistema:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                }
            }

            // Validar que se encontró un driver válido
            if (!selectedDriver) {
                const errorMsg = 'No se encontró un driver válido para el vehículo ' + route.vehiculo_id + '. Asegúrese de tener suficientes conductores registrados en el sistema.';
                console.error('❌ Error:', errorMsg);
                console.log('📋 Drivers disponibles:', this.state.data.drivers);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError(errorMsg);
                }
                throw new Error(errorMsg);
            }

            const driverId = selectedDriver.id;

            console.log('📋 RUTA PROCESADA - vehiculo_id:', route.vehiculo_id, 'matricula:', route.matricula, '→ Driver ID:', driverId, 'Driver:', selectedDriver.user.name);

            // Obtener la sucursal base del driver
            const branchOrigin = selectedDriver && selectedDriver.branch ? selectedDriver.branch :
                (this.state.data.selectedBranch ||
                    (this.state.data.branchList && this.state.data.branchList.find(branch =>
                        this.state.selectedBranches.includes(branch.id)
                    )));

            // Procesar cada día de la ruta (para multiday) o la ruta completa (para single-day)
            const diasArray = route.dias || [{
                dia: 1,
                paradas: route.paradas,
                cargaTotalRutaDiaCajas: route.cargaTotalRutaCajas,
                distanciaTotalRutaDiaKm: route.kilometrajeTotalRutaKm
            }];

            diasArray.forEach((diaData: any) => {
                // Para single-day, acumular estadísticas (para multiday ya las tenemos del resumen)
                if (!this.state.multidayRoutesData) {
                    totalKm += diaData.distanciaTotalRutaDiaKm || 0;
                    totalBoxes += diaData.cargaTotalRutaDiaCajas || 0;
                }

                // Crear routeVisitsDetail basado en las paradas del día
                const routeVisitsDetail: any[] = [];
                if (diaData.paradas && diaData.paradas.length > 0) {
                    const origenCoords = branchOrigin ? [branchOrigin.location.lng, branchOrigin.location.lat] : [0, 0];
                    const origenName = branchOrigin ? branchOrigin.name : 'Origen';
                    // Incluir tanto paradas de Cliente como de Descanso
                    const paradasClientes = diaData.paradas.filter((p: any) => p.tipoParada === "Cliente" || p.tipoParada === "Descanso");
                    const depositoSalida = diaData.paradas.find((p: any) => p.tipoParada === "Depósito (Salida)");
                    const depositoLlegada = diaData.paradas.find((p: any) => p.tipoParada === "Depósito (Llegada)");

                    // Crear races entre paradas
                    for (let j = 0; j < paradasClientes.length; j++) {
                        const paradaActual = paradasClientes[j];
                        const esDescanso = paradaActual.tipoParada === "Descanso";
                        let origenTrayecto;
                        let destinoTrayecto;
                        let clienteDestino;
                        let clienteOrigen;

                        if (j === 0) {
                            const origen = depositoSalida || { nombreSucursal: origenName, coordenadas_lon_lat: origenCoords, coordenadas_lat_lon: [origenCoords[1], origenCoords[0]] };
                            origenTrayecto = {
                                street1: origen.nombreSucursal,
                                lat: origen.coordenadas_lat_lon ? origen.coordenadas_lat_lon[0] : origenCoords[1],
                                lng: origen.coordenadas_lon_lat ? origen.coordenadas_lon_lat[0] : origenCoords[0]
                            };
                            destinoTrayecto = {
                                street1: paradaActual.nombreSucursal,
                                lat: paradaActual.coordenadas_lat_lon ? paradaActual.coordenadas_lat_lon[0] : 0,
                                lng: paradaActual.coordenadas_lon_lat ? paradaActual.coordenadas_lon_lat[0] : 0
                            };
                            clienteDestino = paradaActual;
                            clienteOrigen = null;
                        } else {
                            const paradaAnterior = paradasClientes[j - 1];
                            origenTrayecto = {
                                street1: paradaAnterior.nombreSucursal,
                                lat: paradaAnterior.coordenadas_lat_lon ? paradaAnterior.coordenadas_lat_lon[0] : 0,
                                lng: paradaAnterior.coordenadas_lon_lat ? paradaAnterior.coordenadas_lon_lat[0] : 0
                            };
                            destinoTrayecto = {
                                street1: paradaActual.nombreSucursal,
                                lat: paradaActual.coordenadas_lat_lon ? paradaActual.coordenadas_lat_lon[0] : 0,
                                lng: paradaActual.coordenadas_lon_lat ? paradaActual.coordenadas_lon_lat[0] : 0
                            };
                            clienteDestino = paradaActual;
                            clienteOrigen = paradaAnterior;
                        } const branchDestinoId = esDescanso ? null : this.getBranchIdByName(clienteDestino.nombreSucursal);
                        const branchOrigenId = j === 0
                            ? (branchOrigin ? branchOrigin.id : null)
                            : (clienteOrigen ? (clienteOrigen.tipoParada === "Descanso" ? null : this.getBranchIdByName(clienteOrigen.nombreSucursal)) : null);

                        routeVisitsDetail.push({
                            client: {
                                id: esDescanso ? null : (branchDestinoId || clienteDestino.nodoId || (j + 1)),
                                user: {
                                    name: clienteDestino.nombreSucursal || `Parada ${j + 1}`,
                                    email: ''
                                },
                                phone: ''
                            },
                            visitDateTime: clienteDestino.horaLlegada ?
                                new Date(new Date().toDateString() + ' ' + clienteDestino.horaLlegada) :
                                new Date(),
                            location: {
                                lat: destinoTrayecto.lat,
                                lng: destinoTrayecto.lng,
                                observation: esDescanso ? `Punto de descanso - ${clienteDestino.nombreSucursal}` : undefined
                            },
                            observation: esDescanso 
                                ? `Descanso programado - Tiempo: ${clienteDestino.ventanaTiempo || 'Sin restricción'}`
                                : `Cajas a entregar: ${clienteDestino.cajasAEntregar}, Ventana: ${clienteDestino.ventanaTiempo || 'Sin restricción'}`,
                            order: j + 1,
                            street1: destinoTrayecto.street1,
                            type: 'REMISION',
                            amount: this.props.config.races.pricePerKm,
                            driver: selectedDriver,
                            clientName: clienteDestino.nombreSucursal,
                            clientDocument: '',
                            origin: origenTrayecto,
                            destiny: destinoTrayecto,
                            dueDate: clienteDestino.horaLlegada ?
                                format(new Date(new Date().toDateString() + ' ' + clienteDestino.horaLlegada), "YYYY-MM-DDTHH:mm:ssZ") :
                                format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                            tipoComprobante: 'FAC',
                            nroComprobante: 0,
                            id: esDescanso ? null : (branchDestinoId || clienteDestino.nodoId || (j + 1)),
                            branchId: branchDestinoId,
                            branchOriginId: branchOrigenId || null,
                            branchDestinyId: branchDestinoId || null
                        });
                    }

                    // Agregar race final de retorno
                    if (paradasClientes.length > 0) {
                        const ultimaParadaCliente = paradasClientes[paradasClientes.length - 1];
                        const destino = depositoLlegada || { nombreSucursal: origenName, coordenadas_lon_lat: origenCoords, coordenadas_lat_lon: [origenCoords[1], origenCoords[0]] };
                        const branchOrigenRetorno = this.getBranchIdByName(ultimaParadaCliente.nombreSucursal);
                        const branchDestinoRetorno = branchOrigin ? branchOrigin.id : null;

                        routeVisitsDetail.push({
                            client: {
                                id: 9999,
                                user: {
                                    name: destino.nombreSucursal + ' (Retorno)',
                                    email: ''
                                },
                                phone: ''
                            },
                            visitDateTime: new Date(),
                            location: {
                                lat: destino.coordenadas_lat_lon ? destino.coordenadas_lat_lon[0] : origenCoords[1],
                                lng: destino.coordenadas_lon_lat ? destino.coordenadas_lon_lat[0] : origenCoords[0]
                            },
                            observation: 'Retorno al depósito',
                            order: paradasClientes.length + 1,
                            street1: destino.nombreSucursal,
                            type: 'RETORNO',
                            amount: this.props.config.races.pricePerKm,
                            driver: selectedDriver ? selectedDriver.id : route.vehiculo_id,
                            clientName: destino.nombreSucursal,
                            clientDocument: '',
                            origin: {
                                street1: ultimaParadaCliente.nombreSucursal,
                                lat: ultimaParadaCliente.coordenadas_lat_lon ? ultimaParadaCliente.coordenadas_lat_lon[0] : 0,
                                lng: ultimaParadaCliente.coordenadas_lon_lat ? ultimaParadaCliente.coordenadas_lon_lat[0] : 0
                            },
                            destiny: {
                                street1: destino.nombreSucursal,
                                lat: destino.coordenadas_lat_lon ? destino.coordenadas_lat_lon[0] : origenCoords[1],
                                lng: destino.coordenadas_lon_lat ? destino.coordenadas_lon_lat[0] : origenCoords[0]
                            },
                            dueDate: format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                            tipoComprobante: 'FAC',
                            nroComprobante: 0,
                            id: 9999,
                            branchOriginId: branchOrigenRetorno || null,
                            branchDestinyId: branchDestinoRetorno
                        });
                    }
                }            // Crear RaceSchedule para este día
                // Calcular la fecha para este día específico (planningStartDate + (order - 1) días)
                // Usar fecha local sin conversión UTC
                const planningStartDateString = this.state.planningStartDate;
                let dayDate: Date;
                if (planningStartDateString) {
                    // Crear fecha desde string YYYY-MM-DD sin conversión UTC
                    const parts = planningStartDateString.split('-');
                    dayDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
                } else {
                    // Usar fecha actual sin conversión UTC
                    dayDate = new Date();
                }
                // Sumar días según el día de la planificación
                dayDate.setDate(dayDate.getDate() + ((diaData.dia || 1) - 1));

                // Construir la fecha manualmente sin zona horaria, usando la hora de inicio de jornada
                const year = dayDate.getFullYear();
                const month = String(dayDate.getMonth() + 1).padStart(2, '0');
                const day = String(dayDate.getDate()).padStart(2, '0');
                const scheduleDateWithJornada = `${year}-${month}-${day}T${this.state.horarioInicioJornada}:00`;

                console.log('Fecha calculada para día', diaData.dia, ':', scheduleDateWithJornada);

                const raceSchedule: RaceSchedule = {
                    visitDateTimeSchedule: scheduleDateWithJornada,
                    selectedDriver: selectedDriver ? selectedDriver.id : route.vehiculo_id,
                    limit: this.state.limit,
                    order: diaData.dia || 1, // El día se usa como order (día 1, día 2, etc.)
                    races: routeVisitsDetail.map((item: any, index: number) => {
                        const race: any = {
                            clientId: item.branchId || item.client.id,
                            visitDateTime: format(item.visitDateTime, "YYYY-MM-DDTHH:mm:ssZ"),
                            location: {
                                lat: item.location.lat,
                                lng: item.location.lng,
                            },
                            obs: item.observation ? item.observation : '',
                            order: index + 1,
                            street1: item.street1,
                            type: item.type ? item.type : 'REMISION',
                            amount: item.amount && item.amount !== 0 ? item.amount : this.props.config.races.pricePerKm,
                            driver: selectedDriver ? selectedDriver.id : (route.matricula ? this.getDriverIdByMatricula(route.matricula) || route.vehiculo_id : route.vehiculo_id),
                            clientName: item.clientName,
                            clientDocument: item.clientDocument,
                            origin: item.origin,
                            destiny: item.destiny,
                            dueDate: item.dueDate && item.dueDate !== '' ?
                                format(new Date(item.dueDate), "YYYY-MM-DDTHH:mm:ssZ") :
                                format(new Date(), "YYYY-MM-DDTHH:mm:ssZ"),
                            tipoComprobante: item.tipoComprobante ? item.tipoComprobante : 'FAC',
                            nroComprobante: item.nroComprobante ? item.nroComprobante : 0,
                            observation: item.observation ? item.observation : '',
                            branchOriginId: item.branchOriginId,
                            branchDestinyId: item.branchDestinyId
                        };

                        if (branchOrigin) {
                            race.branch = branchOrigin;
                        }

                        return race;
                    })
                };

                // Agrupar por driver
                if (!routingsByDriver[driverId]) {
                    routingsByDriver[driverId] = [];
                }
                routingsByDriver[driverId].push(raceSchedule);
            }); // Cierre del forEach de diasArray
        }); // Cierre del forEach de routesData

        // Crear array de routings (no necesitamos reasignar order, ya está correcto)
        const routings: Routing[] = Object.keys(routingsByDriver).map(driverId => {
            return {
                driverId: parseInt(driverId, 10),
                raceSchedules: routingsByDriver[driverId]
            };
        });


        // Calcular planningDate y planningEndDate en formato ISO
        const planningStartDateStringD = this.state.planningStartDate || format(new Date(), "YYYY-MM-DDT00:00Z");
        const planningStartDateObj = new Date(planningStartDateStringD);
        const planningDate = planningStartDateObj.toISOString();

        // planningEndDate = fecha inicial + (totalDays - 1) días en formato ISO
        const planningEndDateObj = new Date(planningStartDateObj);
        planningEndDateObj.setDate(planningEndDateObj.getDate() + (totalDays - 1));
        const planningEndDate = planningEndDateObj.toISOString();

        // Crear Planning sin ID
        const planning: Planning = {
            // id: '', // Sin ID inicial, se asignará en el backend
            totalKm: Math.round(totalKm * 100) / 100, // Redondear a 2 decimales
            totalVehicles: totalVehicles,
            totalBoxes: totalBoxes,
            totalDays: totalDays,
            planningDate: planningDate,
            planningEndDate: planningEndDate,
            routings: routings
        };

        return planning;
    };

    onChangeBranchSelector(e: React.ChangeEvent<any>) {
        const idx = +e.target.value;
        this.setBranch(idx);
    }


    setBranch(idx: number) {
        const branch = this.state.data.branchList ? this.state.data.branchList[idx] : undefined;
        const origin = this.state.data.origin


        if (this.state.data.visitsDetail && this.state.data.visitsDetail.length > 0 && branch) {
            const newVisitDetail = this.state.data.visitsDetail;
            newVisitDetail[0].location = new Dot(branch.location.lat, branch.location.lng);
            // newVisitDetail[0].origin = {
            //     street1: 'Origen',
            //     lat: branch.location.lat,
            //     lng: branch.location.lng
            // }
            // Se vuelve a cambiar el origen del primer elemento que justamente no sea el origen de la ruta
            if (this.state.data.visitsDetail.length === 2) {
                newVisitDetail[this.state.data.visitsDetail.length - 1].origin = {
                    street1: 'Origen',
                    lat: branch.location.lat,
                    lng: branch.location.lng
                }
            }

            this.setState({
                data: {
                    ...this.state.data,
                    selectedBranch: branch,
                    origin: branch ? new Dot(branch.location.lat, branch.location.lng) : origin,
                    visitsDetail: newVisitDetail,
                }
            });
        }
    }








    handleSubmit = async () => {
        // Verificar si tenemos datos de rutas multiday
        const hasMultiDayRoutes = this.state.multidayRoutesData && this.state.multidayRoutesData.rutas && this.state.multidayRoutesData.rutas.length > 0;

        if (hasMultiDayRoutes && this.state.multidayRoutesData) {
            console.log('Procesando rutas multi-día');
            const routesToProcess = this.state.multidayRoutesData.rutas;

            // Obtener todos los conductores seleccionados de manera similar al render
            const selectedDriversData = this.state.data.drivers && this.state.data.drivers.filter(driver =>
                this.state.selectedDrivers.includes(driver.id)
            ) || [];

            // Crear la estructura Planning primero para calcular el total real de raceSchedules
            const planning: Planning = this.createPlanningStructure(routesToProcess, selectedDriversData);

            // Calcular el número total real de raceSchedules (días) a crear
            const totalRaces = planning.routings.reduce((sum, routing) => sum + routing.raceSchedules.length, 0);

            // Inicializar progreso
            this.setState({
                isCreatingRaces: true,
                racesCreationProgress: 0,
                totalRacesToCreate: totalRaces,
                racesCreated: 0
            });

            // Mostrar notificación de inicio
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addInfo) {
                this.props.notification.notification.addInfo('Iniciando creación de carreras', `Creando ${totalRaces} repartos...`);
            }

            try {

                // Log de la estructura para verificación
                console.log('Planning creado:', planning, null, 2);

                // Aquí puedes enviar el Planning completo al backend
                this.props.sendData(planning);

                // Mostrar notificación de inicio
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addInfo) {
                    this.props.notification.notification.addInfo('Iniciando creación de carreras', `Creando ${totalRaces} programación de repartos`);
                }

                // O si prefieres enviar cada RaceSchedule individualmente como antes:
                for (const routing of planning.routings) {
                    for (let i = 0; i < routing.raceSchedules.length; i++) {
                        const raceSchedule = routing.raceSchedules[i];

                        // Actualizar progreso
                        const currentIndex = planning.routings
                            .slice(0, planning.routings.indexOf(routing))
                            .reduce((sum, r) => sum + r.raceSchedules.length, 0) + i;

                        this.setState(prevState => ({
                            racesCreationProgress: (currentIndex / totalRaces) * 100,
                        }));

                        // Pequeña pausa para mostrar progreso visualmente
                        await new Promise(resolve => setTimeout(resolve, 200));

                        try {
                            // Enviar datos individualmente para cada raceSchedule
                            console.log('Enviando RaceSchedule para driver:', routing.driverId, 'Día:', raceSchedule.order, raceSchedule);
                            // this.props.sendData(raceSchedule);
                        } catch (immediateError) {
                            console.error(`Error inmediato enviando día ${raceSchedule.order} del driver ${routing.driverId}:`, immediateError);
                            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                                this.props.notification.notification.addError('Error de conexión', `No se pudo enviar el día ${raceSchedule.order} del driver ${routing.driverId}`);
                            }
                        }

                        // Actualizar progreso - race completado
                        this.setState(prevState => ({
                            racesCreated: prevState.racesCreated + 1,
                            racesCreationProgress: ((currentIndex + 1) / totalRaces) * 100
                        }));
                    }
                }

                // Mostrar progreso completo por un momento
                await new Promise(resolve => setTimeout(resolve, 500));

                // Mostrar resumen del planning después de completar el progreso
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addInfo) {
                    this.props.notification.notification.addInfo(
                        'Planning creado',
                        `Total KM: ${planning.totalKm}, Vehículos: ${planning.totalVehicles}, Cajas: ${planning.totalBoxes}, Drivers: ${planning.routings.length}`
                    );
                }

            } catch (error) {
                console.error('Error creando carreras:', error);
                // Mostrar notificación de error directamente
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError('Error al crear las carreras', `Se produjo un error: ${error.message || error}`);
                } else {
                    alert(`Error al crear las carreras: ${error.message || error}`);
                }
            } finally {
                // Aquí solo reseteamos el estado de progreso
                this.setState({
                    isCreatingRaces: false,
                    racesCreationProgress: 0,
                    totalRacesToCreate: 0,
                    racesCreated: 0
                });
            }

            return;
        }

        // Component is now multiday-only, no single-visit functionality
        this.props.notification.notification.addWarning('Esta funcionalidad requiere datos de rutas multi-día');
    }

    // Form methods for CSV upload
    handleVehicleCapacityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ vehicleCapacityBoxes: event.target.value });
    };

    handleNumVehiclesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ numVehicles: event.target.value });
    };

    handleDepotIndexChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ depotIndex: parseInt(event.target.value, 10) || 0 });
    };

    handleServiceTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ serviceTime: parseInt(event.target.value, 10) || 10 });
    };

    handleDemandUnitChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ demandUnit: event.target.value as string });
    };

    handleCapacityUnitChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ capacityUnit: event.target.value as string });
    };

    handleBoxVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ boxVolumeM3: parseFloat(event.target.value) || 0 });
    };

    // Método auxiliar para parsear líneas CSV correctamente
    parseCSVLine = (line: string): string[] => {
        const result: string[] = [];
        let current = '';
        let inQuotes = false;

        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            const nextChar = line[i + 1];

            if (char === '"') {
                if (inQuotes && nextChar === '"') {
                    // Comilla escapada dentro de comillas (comillas dobles consecutivas)
                    current += '"';
                    i++; // Saltar la siguiente comilla
                } else {
                    // Entrar o salir de modo comillas
                    inQuotes = !inQuotes;
                }
            } else if (char === ',' && !inQuotes) {
                // Fin de campo
                result.push(current);
                current = '';
            } else {
                current += char;
            }
        }

        // Agregar el último campo
        result.push(current);

        return result;
    };

    // Método auxiliar para crear un mapeo dinámico de headers (nombres de columnas -> índices)
    createHeaderMapping = (headerLine: string): { [key: string]: number } => {
        const headers = this.parseCSVLine(headerLine);
        const mapping: { [key: string]: number } = {};

        headers.forEach((header, index) => {
            const cleanHeader = header.trim().toLowerCase();
            mapping[cleanHeader] = index;
        });

        console.log('📋 Mapeo de headers creado:', Object.keys(mapping));
        return mapping;
    };

    // Método auxiliar para extraer valores usando el mapeo de headers
    getValueByHeader = (values: string[], headerMap: { [key: string]: number }, headerName: string, defaultValue: string = ''): string => {
        const index = headerMap[headerName.toLowerCase()];
        if (index !== undefined && index < values.length) {
            return values[index].trim();
        }
        console.warn(`⚠️ Header "${headerName}" no encontrado en el mapeo. Headers disponibles:`, Object.keys(headerMap));
        return defaultValue;
    };

    // Método para procesar y registrar sucursales nuevas desde CSV
    processNewBranchesFromCSV = async (newBranches: any[]) => {
        if (newBranches.length === 0) {
            return;
        }

        // Verificar si hay callback disponible
        if (!this.props.onCreateBranches) {
            console.warn('No hay callback onCreateBranches disponible para crear sucursales');
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning(
                    'Funcionalidad no disponible',
                    'No se puede registrar sucursales desde CSV en este contexto'
                );
            }
            return;
        }

        console.log('=== Registrando sucursales nuevas desde CSV ===');
        console.log('Sucursales a registrar:', newBranches.length);

        // Inicializar progreso
        this.setState({
            isCreatingBranches: true,
            branchesCreationProgress: 0,
            totalBranchesToCreate: newBranches.length,
            branchesCreated: 0,
            currentBatch: 0,
            totalBatches: Math.ceil(newBranches.length / 10), // Asumiendo batch size de 10
            isCancellingBranches: false,
            retryAttempts: 0,
            creationSummary: null
        });

        try {
            // Preparar los payloads de las sucursales nuevas
            const branchPayloads = newBranches.map((branchData) => {
                // Parsear ventana de tiempo (formato esperado: "HH:mm-HH:mm")
                let inicioVentana = "";
                let finVentana = "";
                if (branchData.ventana_tiempo && branchData.ventana_tiempo.includes('-')) {
                    const partes = branchData.ventana_tiempo.split('-');
                    inicioVentana = partes[0].trim();
                    finVentana = partes[1].trim();
                }

                return {
                    name: branchData.sucNom,
                    lat: branchData.sucLat,
                    lng: branchData.sucLon,
                    street1: branchData.sucNom, // Usar el nombre como dirección por defecto
                    street2: "", // Campo opcional vacío
                    observation: "Creada desde CSV - Ventana: " + branchData.ventana_tiempo + ", Cajas: " + branchData.can_cajas,
                    maxDistanceValidation: false, // Valor por defecto
                    maxDistance: 0, // Valor por defecto
                    inicioVentana: inicioVentana,
                    finVentana: finVentana
                };
            });

            console.log('Payloads preparados:', branchPayloads);

            // Llamar al callback del componente padre
            await this.props.onCreateBranches(branchPayloads);

            // Actualizar progreso final
            this.setState({
                branchesCreated: newBranches.length,
                branchesCreationProgress: 100
            });

            // Mostrar notificación de éxito
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                this.props.notification.notification.addSuccess(
                    'Sucursales registradas exitosamente',
                    `Se registraron ${newBranches.length} sucursales nuevas desde el CSV.`
                );
            }



            console.log('=== Registro completado ===');
            console.log('Total sucursales registradas:', newBranches.length);

        } catch (error) {
            console.error('Error durante el registro de sucursales:', error);
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                this.props.notification.notification.addError(
                    'Error al registrar sucursales',
                    'Ocurrió un error durante el proceso de registro. Revisa la consola para más detalles.'
                );
            }
        } finally {
            // Limpiar estado de progreso después de un breve delay
            setTimeout(() => {
                this.setState({
                    isCreatingBranches: false,
                    branchesCreationProgress: 0,
                    totalBranchesToCreate: 0,
                    branchesCreated: 0
                });
            }, 2000);
        }
    };

    processNewDriversFromCSV = async (newDrivers: any[]) => {
        if (newDrivers.length === 0) {
            return;
        }

        // Verificar si hay callback disponible
        if (!this.props.onCreateDrivers) {
            console.warn('No hay callback onCreateDrivers disponible para crear choferes');
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addWarning) {
                this.props.notification.notification.addWarning(
                    'Funcionalidad no disponible',
                    'No se puede registrar choferes desde CSV en este contexto'
                );
            }
            return;
        }

        console.log('=== Registrando choferes nuevos desde CSV ===');
        console.log('Choferes a registrar:', newDrivers.length);

        // Inicializar progreso
        this.setState({
            isCreatingDrivers: true,
            driversCreationProgress: 0,
            totalDriversToCreate: newDrivers.length,
            driversCreated: 0,
            currentDriverBatch: 0,
            totalDriverBatches: Math.ceil(newDrivers.length / 10), // Asumiendo batch size de 10
            isCancellingDrivers: false,
            driverRetryAttempts: 0,
            driverCreationSummary: null
        });

        try {
            // Preparar los payloads de los choferes nuevos
            const driverPayloads = newDrivers.map((driverData) => {
                const tempPassword = 'TempPass123!';
                const randomSuffix = Math.floor(Math.random() * 10000);
                const tempEmail = `${driverData.chofer.toLowerCase().replace(/\s+/g, '.')}.${randomSuffix}@temp.com`;

                // Determinar el tipo de vehículo según medida_furgon
                let vehicleType: VehicleType = 'CAR';
                if (driverData.medidaFurgon && driverData.medidaFurgon.toUpperCase() === 'MOTORCYCLE') {
                    vehicleType = 'MOTORCICLE';
                } else if (driverData.medidaFurgon && (driverData.medidaFurgon.toUpperCase().includes('GRANDE') || driverData.m3 > 20)) {
                    vehicleType = 'TRUCK';
                }

                // Crear el vehículo usando la interfaz ApiVehicle del modelo
                const vehicle: ApiVehicle = {
                    brand: driverData.marca || 'GENERICO',
                    model: driverData.modelo || '',
                    type: vehicleType,
                    year: '',
                    capacidadVolumetrica: driverData.m3 || 0,
                    image: '',
                    fixedPayment: 0,
                    paymentPerKm: 0
                };

                return {
                    user: {
                        name: driverData.chofer,
                        email: tempEmail,
                        password: tempPassword
                    },
                    driver: {
                        region: 'DEFAULT',
                        registryNumber: driverData.matricula,
                        registryDate: new Date().toISOString().split('T')[0],
                        phone: 'Sin teléfono',
                        document: 'Sin documento',
                        type: 'REMISION',
                        referenceId: 0,
                        notifyLocation: true,
                        notifyLogout: true,
                        recordLocation: true,
                        outsourced: false,
                        fixedPayment: 0,
                        paymentPerKm: 0
                    },
                    vehicles: [vehicle], // Array de vehículos según el nuevo formato DriverForm
                    branch: driverData.branchId || 0, // Solo el ID de la sucursal, no un objeto,
                    driverPassw: tempPassword // Contraseña temporal para el chofer
                };
            });

            console.log('Payloads preparados:', driverPayloads);

            // Llamar al callback del componente padre
            await this.props.onCreateDrivers(driverPayloads);

            // Refrescar la lista de drivers después de crearlos
            if (this.props.driverActions && this.props.driverActions.actions && this.props.driverActions.actions.fetch) {
                await this.props.driverActions.actions.fetch();
            }

            // Actualizar progreso final
            this.setState({
                driversCreated: newDrivers.length,
                driversCreationProgress: 100
            });

            // Mostrar notificación de éxito
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                this.props.notification.notification.addSuccess(
                    'Choferes registrados exitosamente',
                    `Se registraron ${newDrivers.length} choferes nuevos desde el CSV.`
                );
            }

            console.log('=== Registro completado ===');
            console.log('Total choferes registrados:', newDrivers.length);

        } catch (error) {
            console.error('Error durante el registro de choferes:', error);
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                this.props.notification.notification.addError(
                    'Error al registrar choferes',
                    'Ocurrió un error durante el proceso de registro. Revisa la consola para más detalles.'
                );
            }
        } finally {
            // Limpiar estado de progreso después de un breve delay
            setTimeout(() => {
                this.setState({
                    isCreatingDrivers: false,
                    driversCreationProgress: 0,
                    totalDriversToCreate: 0,
                    driversCreated: 0,
                    currentDriverBatch: 0,
                    totalDriverBatches: 0
                });
            }, 2000);
        }
    };

    handleLocationsFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;

        if (!file) {
            this.setState({ csvLocationsFile: null });
            return;
        }

        this.setState({ csvLocationsFile: file });

        // Leer y procesar el archivo CSV
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            try {
                const target = e.target as FileReader;
                const text = target && target.result ? target.result as string : '';
                const lines = text.split('\n');

                // Obtener el arreglo de branches
                const branches = this.state.data.branchList || [];
                console.log('📍 Branches disponibles en el sistema:', branches.length);

                // Parsear encabezados y crear mapeo dinámico
                const headerLine = lines[0];
                const headerMapping = this.createHeaderMapping(headerLine);

                // Validar que existan los headers requeridos
                const requiredHeaders = ['suc_nom', 'suc_lon', 'suc_lat', 'ventana_tiempo', 'demanda'];
                const missingHeaders = requiredHeaders.filter(h => !(h.toLowerCase() in headerMapping));
                if (missingHeaders.length > 0) {
                    throw new Error(`Headers faltantes en el CSV: ${missingHeaders.join(', ')}`);
                }

                // Saltar la primera línea (encabezados)
                const dataLines = lines.slice(1).filter((line) => {
                    return line.trim() !== '';
                });

                console.log('=== Procesando CSV de Sucursales ===');
                console.log('Total de líneas en CSV: ' + dataLines.length);
                console.log('Total de branches existentes: ' + branches.length);

                // Procesar cada línea del CSV
                const results = dataLines.map((line, index) => {
                    try {
                        // Parsear la línea CSV
                        const values = this.parseCSVLine(line);

                        const cleanValues = values.map((v: string) => {
                            let cleaned = v.trim();
                            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                                cleaned = cleaned.slice(1, -1);
                                cleaned = cleaned.replace(/""/g, '"');
                            }
                            return cleaned;
                        });

                        // Usar mapeo dinámico para extraer valores
                        const sucNom = this.getValueByHeader(cleanValues, headerMapping, 'suc_nom');
                        const sucLon = this.getValueByHeader(cleanValues, headerMapping, 'suc_lon');
                        const sucLat = this.getValueByHeader(cleanValues, headerMapping, 'suc_lat');
                        const ventanaTiempo = this.getValueByHeader(cleanValues, headerMapping, 'ventana_tiempo');
                        const canCajasStr = this.getValueByHeader(cleanValues, headerMapping, 'demanda');

                        // Validar que los campos requeridos no estén vacíos
                        if (!sucNom || !sucLon || !sucLat) {
                            console.warn(`Línea ${index + 2} tiene campos requeridos vacíos:`, { sucNom, sucLon, sucLat });
                            return null;
                        }

                        // Validar demanda
                        const canCajas = parseInt(canCajasStr, 10);
                        if (isNaN(canCajas)) {
                            console.warn(`Línea ${index + 2} tiene demanda inválida: "${canCajasStr}". Se usará 0`);
                        }

                        // Buscar si la sucursal ya existe en branches
                        let existingBranch = null;
                        const sucNomLower = sucNom.toLowerCase().trim();

                        existingBranch = branches.find((branch: BranchData) => {
                            if (!branch.name || branch.name.trim() === '') { return false; }
                            return branch.name.toLowerCase().trim() === sucNomLower;
                        });

                        const result = {
                            linea: index + 2,
                            sucNom: sucNom,
                            sucCallePrincipal: sucNom,
                            sucLon: parseFloat(sucLon),
                            sucLat: parseFloat(sucLat),
                            ventanaTiempo: ventanaTiempo,
                            canCajas: isNaN(canCajas) ? 0 : canCajas,
                            existe: !!existingBranch,
                            branchId: existingBranch ? existingBranch.id : null
                        };

                        return result;
                    } catch (error) {
                        console.error(`Error procesando línea ${index + 2}:`, line, error);
                        return null;
                    }
                });

                // Contar líneas procesadas vs descartadas
                const totalLines = dataLines.length;
                const processedLines = results.filter(r => r !== null).length;
                const discardedLines = totalLines - processedLines;

                console.log(`\n=== Resumen de procesamiento CSV ===`);
                console.log(`Total de líneas en CSV: ${totalLines}`);
                console.log(`Líneas procesadas correctamente: ${processedLines}`);
                console.log(`Líneas descartadas: ${discardedLines}`);
                if (discardedLines > 0) {
                    console.warn(`⚠️  Se descartaron ${discardedLines} líneas. Revisa los warnings anteriores para detalles.`);
                }
                console.log(`===================================\n`);

                const validResults = results.filter((r) => {
                    return r !== null;
                });

                // Resumen
                const existentes = validResults.filter((r) => {
                    return r && r.existe;
                }).length;
                const noExistentes = validResults.filter((r) => {
                    return r && !r.existe;
                }).length;

                console.log('\n=== Resumen ===');
                console.log('Sucursales existentes: ' + existentes);
                console.log('Sucursales NO existentes: ' + noExistentes);
                console.log('===============\n');

                // Calcular suma total de demanda (cajas)
                const totalDemand = validResults.reduce((sum, result) => {
                    const cajasValue = result && result.canCajas ? result.canCajas : 0;
                    return sum + cajasValue;
                }, 0);

                console.log(`📊 Suma total de demanda (cajas): ${totalDemand}`);
                if (validResults.length > 0) {
                    // console.log(`   Primeras 3 líneas:`, validResults.slice(0, 3).map(r => ({ sucNom: r.sucNom, canCajas: r.canCajas })));
                }

                // Mostrar notificación al usuario
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                    if (noExistentes > 0) {
                        this.props.notification.notification.addSuccess(
                            'CSV procesado exitosamente',
                            'Se encontraron ' + existentes + ' sucursales existentes y ' + noExistentes + ' sucursales nuevas que serán registradas en el sistema.'
                        );
                        // Procesar sucursales nuevas
                        this.processNewBranchesFromCSV(validResults.filter((r) => r && !r.existe));
                    } else {
                        this.props.notification.notification.addSuccess(
                            'CSV procesado exitosamente',
                            'Todas las ' + existentes + ' sucursales del CSV ya existen en el sistema.'
                        );
                    }
                }

                // Actualizar estado con la suma total de demanda
                this.setState({
                    totalDemandFromLocationsCSV: totalDemand,
                    locationsCSVLoaded: true
                });

            } catch (error) {
                console.error('Error al procesar el archivo CSV:', error);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError(
                        'Error al procesar CSV',
                        'Verifique que el archivo tenga el formato correcto'
                    );
                }
            }
        };

        reader.readAsText(file);
    };

    handleDriversFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;

        if (!file) {
            this.setState({ csvDriversFile: null });
            return;
        }

        this.setState({ csvDriversFile: file });
        this.setState({ csvFleetFile: file });

        // Refrescar la lista de drivers antes de procesar el CSV
        if (this.props.driverActions && this.props.driverActions.actions && this.props.driverActions.actions.fetch) {
            try {
                await this.props.driverActions.actions.fetch();
                console.log('Lista de drivers refrescada desde store');
            } catch (error) {
                console.warn('Error al refrescar lista de drivers desde store:', error);
            }
        }

        // Leer y procesar el archivo CSV
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            try {
                const target = e.target as FileReader;
                const text = target && target.result ? target.result as string : '';
                const lines = text.split('\n');

                // Obtener el arreglo de drivers
                const drivers = this.state.data.drivers || [];
                console.log('Drivers en estado local antes de procesar:', drivers.length);

                // Parsear encabezados y crear mapeo dinámico
                const headerLine = lines[0];
                const headerMapping = this.createHeaderMapping(headerLine);

                // Validar que existan los headers requeridos
                const requiredHeaders = ['matricula', 'capacidad', 'chofer', 'marca', 'modelo', 'medida_furgon', 'm3', 'suc'];
                const missingHeaders = requiredHeaders.filter(h => !(h.toLowerCase() in headerMapping));
                if (missingHeaders.length > 0) {
                    throw new Error(`Headers faltantes en el CSV de conductores: ${missingHeaders.join(', ')}`);
                }

                // Saltar la primera línea (encabezados)
                const dataLines = lines.slice(1).filter((line) => {
                    return line.trim() !== '';
                });

                console.log('=== Procesando CSV de Choferes ===');
                console.log('Total de líneas en CSV: ' + dataLines.length);
                console.log('Total de drivers existentes: ' + drivers.length);

                // Procesar cada línea del CSV
                const results = dataLines.map((line, index) => {
                    // Parsear la línea CSV
                    const values = this.parseCSVLine(line);

                    const cleanValues = values.map((v: string) => {
                        let cleaned = v.trim();
                        if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                            cleaned = cleaned.slice(1, -1);
                            cleaned = cleaned.replace(/""/g, '"');
                        }
                        return cleaned;
                    });

                    // Usar mapeo dinámico para extraer valores
                    const matriculaCSV = this.getValueByHeader(cleanValues, headerMapping, 'matricula');
                    const capacidadCSVStr = this.getValueByHeader(cleanValues, headerMapping, 'capacidad');
                    const choferCSV = this.getValueByHeader(cleanValues, headerMapping, 'chofer');
                    const marcaCSV = this.getValueByHeader(cleanValues, headerMapping, 'marca');
                    const modeloCSV = this.getValueByHeader(cleanValues, headerMapping, 'modelo');
                    const medidaFurgonCSV = this.getValueByHeader(cleanValues, headerMapping, 'medida_furgon');
                    const m3CSVStr = this.getValueByHeader(cleanValues, headerMapping, 'm3');
                    const sucCSV = this.getValueByHeader(cleanValues, headerMapping, 'suc');

                    if (!matriculaCSV || !choferCSV) {
                        console.warn(`Línea ${index + 2} tiene campos requeridos vacíos`);
                        return null;
                    }

                    // Validar capacidad y m3
                    const capacidadCSV = parseFloat(capacidadCSVStr);
                    const m3CSV = parseFloat(m3CSVStr);

                    if (isNaN(capacidadCSV)) {
                        console.warn(`Línea ${index + 2} tiene capacidad inválida: "${capacidadCSVStr}". Se usará 0`);
                    }
                    if (isNaN(m3CSV)) {
                        console.warn(`Línea ${index + 2} tiene m3 inválido: "${m3CSVStr}". Se usará 0`);
                    }

                    // Buscar si el conductor ya existe por matrícula
                    let existingDriver = null;
                    const matriculaLower = matriculaCSV.toLowerCase().trim();

                    existingDriver = drivers.find((driver: any) => {
                        if (!driver.registryNumber || !driver.registryNumber.trim()) {
                            return false;
                        }
                        return driver.registryNumber.toLowerCase().trim() === matriculaLower;
                    });

                    // También verificar si el conductor está seleccionado en el selector
                    const selectedDrivers = this.state.data.drivers && this.state.data.drivers.filter(driver =>
                        this.state.selectedDrivers.includes(driver.id)
                    ) || [];

                    const existingSelectedDriver = selectedDrivers.find((driver: any) => {
                        if (!driver.registryNumber || !driver.registryNumber.trim()) {
                            return false;
                        }
                        return driver.registryNumber.toLowerCase().trim() === matriculaLower;
                    });

                    // El conductor existe si está en la lista completa O si está seleccionado
                    const driverExists = !!existingDriver || !!existingSelectedDriver;
                    const finalDriverId = existingDriver ? existingDriver.id : (existingSelectedDriver ? existingSelectedDriver.id : null);

                    // Buscar la sucursal SOLO para conductores nuevos
                    let branchId = null;
                    let sucursalEncontrada = false;
                    if (!driverExists && sucCSV) {
                        const branches = this.state.data.branchList || [];
                        const sucLower = sucCSV.toLowerCase().trim();

                        const existingBranch = branches.find((branch: BranchData) => {
                            if (!branch.name || branch.name.trim() === '') {
                                return false;
                            }
                            return branch.name.toLowerCase().trim() === sucLower;
                        });

                        if (existingBranch) {
                            branchId = existingBranch.id;
                            sucursalEncontrada = true;
                        }
                    }

                    const result = {
                        linea: index + 2,
                        matricula: matriculaCSV,
                        capacidad: isNaN(capacidadCSV) ? 0 : capacidadCSV,
                        chofer: choferCSV,
                        marca: marcaCSV,
                        modelo: modeloCSV,
                        medidaFurgon: medidaFurgonCSV,
                        m3: isNaN(m3CSV) ? 0 : m3CSV,
                        suc: sucCSV,
                        existe: driverExists,
                        driverId: finalDriverId,
                        branchId: branchId,
                        sucursalEncontrada: sucursalEncontrada
                    };

                    // console.log('Línea ' + result.linea + ': "' + choferCSV + '" (Mat: ' + matriculaCSV + ') - ' + (result.existe ? 'EXISTE (ID: ' + result.driverId + ')' : 'NO EXISTE'));

                    return result;
                }).filter((r) => {
                    return r !== null;
                });

                // Resumen
                const existentes = results.filter((r) => {
                    // console.log('Revisando existencia para resumen:', r);
                    return r && r.existe;
                }).length;
                const noExistentes = results.filter((r) => {
                    return r && !r.existe;
                }).length;
                const nuevosSinSucursal = results.filter((r) => {
                    return r && !r.existe && !r.sucursalEncontrada;
                }).length;

                // console.log('Choferes existentes: ' + existentes);
                // console.log('Choferes NO existentes: ' + noExistentes);

                // Crear mapeo de matrícula a ID de driver
                const matriculaMapping: { [matricula: string]: number } = {};
                results.forEach((r: any) => {
                    if (r && r.existe && r.driverId && r.matricula) {
                        matriculaMapping[r.matricula.toLowerCase().trim()] = r.driverId;
                    }
                });

                // Actualizar el estado con el mapeo
                this.setState({ matriculaToDriverId: matriculaMapping });

                // Calcular suma total de capacidad desde el campo capacidad del CSV
                const totalCapacity = results.reduce((sum, result) => {
                    const capacidadValue = result && result.capacidad ? result.capacidad : 0;
                    return sum + capacidadValue;
                }, 0);

                console.log(`📊 Suma total de capacidad: ${totalCapacity}`);
                if (results.length > 0) {
                    // console.log(`   Total de conductores parseados: ${results.length}`);
                    // console.log(`   Primeras 3 líneas:`, results.slice(0, 3).map(r => ({ chofer: r.chofer, capacidad: r.capacidad })));
                }

                // Mostrar notificación al usuario
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addSuccess) {
                    if (noExistentes > 0) {
                        let mensaje = 'Se encontraron ' + existentes + ' choferes existentes y ' + noExistentes + ' choferes nuevos que serán registrados en el sistema.';
                        if (nuevosSinSucursal > 0) {
                            mensaje += ' Advertencia: ' + nuevosSinSucursal + ' choferes nuevos no tienen sucursal válida en el CSV y se asignarán a la sucursal por defecto.';
                        }
                        this.props.notification.notification.addSuccess(
                            'CSV de choferes procesado exitosamente',
                            mensaje
                        );
                        // Procesar choferes nuevos
                        this.processNewDriversFromCSV(results.filter((r) => r && !r.existe));
                    } else {
                        this.props.notification.notification.addSuccess(
                            'CSV de choferes procesado exitosamente',
                            'Todos los ' + existentes + ' choferes del CSV ya existen en el sistema.'
                        );
                    }
                }

                // Actualizar estado con la suma total de capacidad
                this.setState({
                    totalCapacityFromFleetCSV: totalCapacity,
                    fleetCSVLoaded: true
                });

            } catch (error) {
                console.error('Error al procesar el archivo CSV de choferes:', error);
                if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                    this.props.notification.notification.addError(
                        'Error al procesar CSV de choferes',
                        'Verifique que el archivo tenga el formato correcto con las columnas: matricula,capacidad,chofer,marca,modelo,chasis,medida_furgon,m3,suc'
                    );
                }
            }
        };

        reader.readAsText(file);
    };

    handleFleetFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;

        if (file) {
            console.log('📁 Procesando archivo CSV de flota:', file.name);
            // Leer el archivo para crear los mapeos
            const reader = new FileReader();
            reader.onload = (e: any) => {
                try {
                    const target = e.target as FileReader;
                    const text = target && target.result ? target.result as string : '';
                    console.log('📄 Contenido del CSV leído:', text.substring(0, 200) + '...');

                    const lines = text.trim().split('\n');
                    console.log('📊 Número de líneas en CSV:', lines.length);

                    // Procesar encabezado para identificar índices de columnas
                    const headerLine = lines[0];
                    const headers = this.parseCSVLine(headerLine);
                    console.log('📋 Encabezados encontrados:', headers);

                    const matriculaIndex = headers.findIndex((h) => h.toLowerCase().includes('matr'));
                    const driverIdIndex = headers.findIndex((h) => h.toLowerCase().includes('id') || h.toLowerCase().includes('driver'));

                    console.log(`🔍 Índice de matrícula: ${matriculaIndex}, Índice de driver ID: ${driverIdIndex}`);

                    const dataLines = lines.slice(1); // Saltar encabezado
                    console.log('📋 Número de líneas de datos:', dataLines.length);

                    const vehicleIndexToDriverIdMapping: { [vehicleIndex: number]: number } = {};
                    const matriculaToDriverIdMapping: { [matricula: string]: number } = {};

                    dataLines.forEach((line, index) => {
                        const fields = this.parseCSVLine(line);
                        console.log(`🔍 Línea ${index + 1}: ${fields.length} campos`);

                        if (fields.length >= 10) {
                            // Columna 10 (índice 9) contiene el driver ID
                            const driverIdStr = fields[9].trim();
                            const driverId = parseInt(driverIdStr, 10);

                            console.log(`🔢 Procesando línea ${index + 1}: campo[9]="${driverIdStr}" → driverId=${driverId}`);

                            if (!isNaN(driverId) && driverId > 0) {
                                // El WebService asigna vehiculo_id como 1, 2, 3, 4... según orden del CSV
                                vehicleIndexToDriverIdMapping[index + 1] = driverId;
                                console.log(`✅ Mapeo creado: vehiculo_id ${index + 1} → driver ID ${driverId}`);

                                // También crear mapeo por matrícula (columna 1, índice 0)
                                if (fields.length > 0) {
                                    const matricula = fields[0].trim();
                                    if (matricula) {
                                        const matriculaKey = matricula.toLowerCase().trim();
                                        matriculaToDriverIdMapping[matriculaKey] = driverId;
                                        console.log(`✅ Mapeo por matrícula creado: "${matricula}" (${matriculaKey}) → driver ID ${driverId}`);
                                    }
                                }
                            } else {
                                console.warn(`⚠️ Driver ID inválido en línea ${index + 1}: "${driverIdStr}"`);
                            }
                        } else {
                            console.warn(`⚠️ Línea ${index + 1} tiene solo ${fields.length} campos (se esperan al menos 10)`);
                        }
                    });

                    console.log('🎯 Mapeo vehiculo_id → driver ID:', vehicleIndexToDriverIdMapping);
                    console.log('🎯 Mapeo matrícula → driver ID:', matriculaToDriverIdMapping);

                    this.setState({
                        csvFleetFile: file,
                        vehicleIndexToDriverId: vehicleIndexToDriverIdMapping,
                        matriculaToDriverId: matriculaToDriverIdMapping
                    });

                    console.log('💾 State actualizado con mapeos de vehículos');
                } catch (error) {
                    console.error('❌ Error al procesar CSV de flota:', error);
                    this.setState({ csvFleetFile: file });
                }
            };
            reader.readAsText(file);
        } else {
            console.log('🗑️ Archivo CSV removido');
            this.setState({ csvFleetFile: null, vehicleIndexToDriverId: {}, matriculaToDriverId: {} });
        }
    };

    handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        console.log('🚀 Iniciando envío del formulario');
        console.log('📊 Estado del mapeo vehicleIndexToDriverId al enviar:', this.state.vehicleIndexToDriverId);


        if (!this.state.csvLocationsFile || !this.state.csvFleetFile) {
            this.props.notification.notification.addWarning('Por favor, seleccione ambos archivos CSV antes de enviar el formulario.');
            return;
        }

        console.log('📊 Mapeo de vehículos disponible:', Object.keys(this.state.vehicleIndexToDriverId).length, 'vehículos');
        console.log('👥 Drivers en el sistema:', this.state.data.drivers && this.state.data.drivers.length || 0);

        this.setState({ isUploading: true });



        try {
            const formData = new FormData();
            formData.append('depot_index', this.state.depotIndex.toString());
            formData.append('service_time', this.state.serviceTime.toString());
            formData.append('hora_inicio_jornada', this.state.horarioInicioJornada);
            formData.append('demand_unit', this.state.demandUnit);
            formData.append('capacity_unit', this.state.capacityUnit);
            formData.append('box_volume_m3', this.state.boxVolumeM3.toString());
            formData.append('csv_locations_file', this.state.csvLocationsFile);
            formData.append('csv_fleet_file', this.state.csvFleetFile);
            formData.append('daily_work_minutes', this.state.dailyWorkMinutes.toString());
            formData.append('work_time_tolerance_minutes', this.state.workTimeToleranceMinutes.toString());
            formData.append('dias_laborales', JSON.stringify(this.state.diasLaborales));
            formData.append('min_travel_time_for_rest_minutes', this.state.min_travel_time_for_rest_minutes.toString());
            // formData.append('max_dias', this.state.maxDiasConsecutivos.toString());

            const requestOptions = {
                method: "POST",
                body: formData,
            };

            const optimizeUrl = `${this.props.config.optimizeApi}/optimize/csv-to-json-multiday/`;
            console.log('🌐 Enviando petición a:', optimizeUrl);
            const response = await fetch(optimizeUrl, requestOptions);

            if (!response.ok) {
                if (response.status === 500) {
                    // Limpiar toda la data relacionada con rutas para error 500
                    this.setState({
                        routesData: [],
                        excludedNodes: [],
                        excludedNodesExpanded: false,
                        showRoutesOnMap: false,
                        selectedRouteId: null,
                        routeDirections: {}
                    });
                    throw new Error('Error interno del servidor (500). Se ha limpiado la información de rutas. Por favor, revise los archivos enviados e intente nuevamente.');
                } else {
                    throw new Error(`Error en la petición: ${response.status} ${response.statusText}`);
                }
            }

            const result = await response.json();

            // Verificar si es un JSON multiday (nuevo formato)
            if (result.modo === 'multi-day' && result.rutas && result.configuracion) {
                console.log('=== RESPUESTA MULTIDAY RECIBIDA ===', result);
                // Procesar como JSON multiday
                this.parseMultidayJSON(result as MultidayRoutesData);
            }
            // Procesar la respuesta y transformar al formato esperado (formato anterior)
            else if (result.routes && Array.isArray(result.routes)) {
                const transformedRoutes = result.routes.map((route: any) => ({
                    vehiculoId: route.vehiculo_id,
                    matricula: route.matricula,
                    driverId: route.matricula ? this.getDriverIdByMatricula(route.matricula) : null,
                    tiempoTotalRutaHhmm: route.tiempoTotalRutaHhmm,
                    kilometrajeTotalRutaKm: route.distanciaTotalRutaKm,
                    cargaTotalRutaCajas: route.cargaTotalRutaCajas,
                    paradas: route.paradas.map((parada: any) => ({
                        secuenciaParada: parada.secuenciaParada,
                        tipoParada: parada.tipoParada,
                        nodoId: parada.nodoId,
                        nombreSucursal: parada.nombreSucursal,
                        branchId: this.getBranchIdByName(parada.nombreSucursal), // ID de sucursal registrada
                        coordenadas: parada.coordenadas,
                        horaLlegada: parada.horaLlegada,
                        horaSalida: parada.horaSalida || null,
                        ventanaTiempo: parada.ventanaTiempo || null,
                        cajasAEntregar: parada.cajasAEntregar
                    }))
                }));

                // Actualizar el estado con las rutas optimizadas y nodos excluidos
                this.setState({
                    routesData: transformedRoutes,
                    excludedNodes: result.excluded_nodes || [],
                    excludedNodesExpanded: false,
                    showRoutesOnMap: true,
                    selectedRouteId: null  // Mostrar todas las rutas por defecto
                });

                this.props.notification.notification.addSuccess(`¡Optimización completada! Se generaron ${transformedRoutes.length} rutas optimizadas.`);
            } else {
                this.props.notification.notification.addError('La respuesta del servidor no tiene el formato esperado.');
            }


        } catch (error) {
            console.error('=== ERROR EN LA PETICIÓN ===');
            console.error('Error:', error);
            this.props.notification.notification.addError(error.message || error);
        } finally {
            this.setState({ isUploading: false });
        }
    };

    // Función helper para mapear nombre de sucursal del WS al ID de sucursal registrada
    getBranchIdByName = (branchName: string): number | null => {
        if (!this.state.data.branchList || !branchName || !branchName.trim()) {
            return null;
        }

        const searchName = branchName.trim().toLowerCase();

        // Búsqueda exacta primero
        const exactMatch = this.state.data.branchList.find(b =>
            Boolean(b.name && b.name.trim().toLowerCase() === searchName)
        );

        if (exactMatch) {
            console.log(`✅ Sucursal encontrada por nombre exacto "${branchName}": ID ${exactMatch.id}`);
            return exactMatch.id;
        }

        // Búsqueda parcial si no hay coincidencia exacta
        const partialMatch = this.state.data.branchList.find(b =>
            Boolean(b.name && b.name.trim().toLowerCase().includes(searchName))
        );

        if (partialMatch) {
            console.log(`⚠️ Sucursal encontrada por búsqueda parcial "${branchName}": ${partialMatch.name} (ID: ${partialMatch.id})`);
            return partialMatch.id;
        }

        console.warn(`❌ No se encontró sucursal para nombre "${branchName}"`);
        return null;
    };

    // Función helper para mapear matrícula del WS al ID de driver registrado
    getDriverIdByMatricula = (matricula: string): number | null => {
        if (!matricula || !matricula.trim()) {
            return null;
        }

        const matriculaKey = matricula.trim().toLowerCase();

        // Primero intentar con el mapeo del CSV (más confiable)
        if (this.state.matriculaToDriverId && this.state.matriculaToDriverId[matriculaKey]) {
            const driverId = this.state.matriculaToDriverId[matriculaKey];
            console.log(`✅ Driver encontrado por mapeo CSV para matrícula "${matricula}": ID ${driverId}`);
            return driverId;
        }

        // Fallback: buscar en la lista de drivers por registryNumber (matricula)
        if (!this.state.data.drivers) {
            return null;
        }

        // Buscar driver por registryNumber (matrícula en el sistema)
        const driverByRegistry = this.state.data.drivers.find(d =>
            Boolean(d.registryNumber && d.registryNumber.trim().toLowerCase() === matriculaKey)
        );

        if (driverByRegistry) {
            console.log(`✅ Driver encontrado por registryNumber para matrícula "${matricula}": ${driverByRegistry.user.name} (ID: ${driverByRegistry.id})`);
            return driverByRegistry.id;
        }

        // Última opción: buscar por nombre del conductor (si coincide exacto)
        // Esto es útil cuando el CSV tiene el nombre del conductor en lugar de matrícula
        const driverByName = this.state.data.drivers.find(d =>
            Boolean(d.user && d.user.name && d.user.name.trim().toLowerCase() === matriculaKey)
        );

        if (driverByName) {
            console.log(`✅ Driver encontrado por nombre para "${matricula}": ${driverByName.user.name} (ID: ${driverByName.id})`);
            return driverByName.id;
        }

        console.warn(`❌ No se encontró driver para "${matricula}" ni en CSV, registryNumber, ni nombre`);
        return null;
    };

    handleRouteSelection = (routeId: number | '') => {
        this.setState({ selectedRouteId: routeId === '' ? null : routeId });
    };

    toggleShowRoutes = () => {
        this.setState(prevState => ({ showRoutesOnMap: !prevState.showRoutesOnMap }));
    };

    toggleMarkersOnly = () => {
        this.setState(prevState => ({
            showMarkersOnly: !prevState.showMarkersOnly,
            // Si activamos solo marcadores, limpiar las rutas cargadas
            routeDirections: prevState.showMarkersOnly ? prevState.routeDirections : {},
            // Si desactivamos showMarkersOnly (queremos ver rutas completas) Y hay un día seleccionado, activar spinner
            // Solo se trazan rutas cuando hay un día específico seleccionado (no cuando es "TODOS LOS DIAS")
            isCalculatingRoutes: (prevState.showMarkersOnly && prevState.selectedDay !== null) ? true : false
        }));
    };

    getSelectedRoute = (): Ruta | null => {
        if (!this.state.selectedRouteId || !this.state.routesData.length) { return null };
        return this.state.routesData.find((route: Ruta) => route.vehiculoId === this.state.selectedRouteId) || null;
    };

    getVehicleByMatricula = (matricula: string | undefined): Vehicle | undefined => {
        if (!matricula) {
            return undefined;
        }

        const matriculaKey = matricula.toLowerCase().trim();
        let selectedDriver: Driver | undefined;

        console.log(`🔍 Buscando conductor para matrícula: "${matricula}"`);

        // 1️⃣ Primero intentar buscar por registryNumber directamente en los drivers
        if (this.state.data.drivers && this.state.data.drivers.length > 0) {
            console.log(`🔑 Buscando por registryNumber: "${matriculaKey}"`);
            selectedDriver = this.state.data.drivers.find(d =>
                d.registryNumber !== undefined && d.registryNumber.toLowerCase().trim() === matriculaKey
            );

            if (selectedDriver) {
                console.log('✅ Conductor encontrado por registryNumber:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                return this.createVehicleFromDriver(selectedDriver);
            } else {
                console.warn(`⚠️ No hay conductor con registryNumber "${matriculaKey}"`);
            }
        }

        // 2️⃣ Si no se encontró, intentar mapeo del CSV si existe
        if (!selectedDriver) {
            const mappedDriverId = this.state.matriculaToDriverId[matriculaKey];
            if (mappedDriverId) {
                console.log(`🗂️ Buscando en mapeo CSV matricula: driver ID ${mappedDriverId}`);
                selectedDriver = this.state.data.drivers && this.state.data.drivers.find(d => d.id === mappedDriverId);
                if (selectedDriver) {
                    console.log('✅ Conductor encontrado por mapeo CSV:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                    return this.createVehicleFromDriver(selectedDriver);
                }
            }
        }

        // 3️⃣ Si no se encontró, intentar mapeo del índice del CSV (usando vehiculo_id como clave aproximada)
        if (!selectedDriver) {
            // Extraer el número de la matrícula si es posible para usarlo como índice
            const numberMatch = matricula.match(/\d+/);
            if (numberMatch) {
                const vehicleIndex = parseInt(numberMatch[0], 10);
                const mappedDriverId = this.state.vehicleIndexToDriverId[vehicleIndex];
                if (mappedDriverId) {
                    console.log(`🗂️ Buscando en mapeo índice CSV: vehiculo_id ${vehicleIndex} → driver ID ${mappedDriverId}`);
                    selectedDriver = this.state.data.drivers && this.state.data.drivers.find(d => d.id === mappedDriverId);
                    if (selectedDriver) {
                        console.log('✅ Conductor encontrado por mapeo índice CSV:', selectedDriver.user.name, '(ID:', selectedDriver.id, ')');
                        return this.createVehicleFromDriver(selectedDriver);
                    }
                }
            }
        }

        console.warn(`❌ No se encontró conductor para matrícula "${matricula}". Verificar mapeos disponibles.`);
        return undefined;
    };

    // Método auxiliar para crear objeto Vehicle a partir de un Driver
    createVehicleFromDriver = (driver: Driver): Vehicle => {
        return {
            id: driver.id,
            placa: driver.registryNumber || `VEH-${driver.id}`,
            marca: driver.vehicle ? driver.vehicle.brand || 'N/A' : 'N/A',
            modelo: driver.vehicle ? driver.vehicle.model || 'N/A' : 'N/A',
            capacidadCajas: driver.vehicle ? Math.round(driver.vehicle.capacidadVolumetrica || 25) : 0,
            conductor: driver,
            estado: 'ACTIVO' as 'ACTIVO' | 'INACTIVO' | 'MANTENIMIENTO'
        };
    };

    openRouteDetailsModal = (route: Ruta) => {
        this.setState({
            showRouteDetailsModal: true,
            selectedRouteForDetails: route
        });
    };

    // Función para abrir detalles de una ruta multiday (convertirla a formato Ruta)
    openMultidayRouteDetailsModal = (vehicleRoute: any, dayRoute: any) => {
        // Convertir formato multiday a formato Ruta para reutilizar el modal existente
        const convertedRoute: any = {
            vehiculoId: vehicleRoute.vehiculo_id,
            matricula: vehicleRoute.matricula,
            driverId: vehicleRoute.driverId,
            fechaEstimadaInicio: vehicleRoute.fecha_estimada_inicio || null,
            fechaDia: dayRoute.fecha || null,
            tiempoTotalRutaHhmm: dayRoute.paradas && dayRoute.paradas.length > 0
                ? `${Math.floor(dayRoute.paradas[dayRoute.paradas.length - 1].tiempo_acumulado_dia_min / 60)}:${String(dayRoute.paradas[dayRoute.paradas.length - 1].tiempo_acumulado_dia_min % 60).padStart(2, '0')}`
                : 'N/A',
            kilometrajeTotalRutaKm: dayRoute.paradas && dayRoute.paradas.length > 0
                ? dayRoute.paradas[dayRoute.paradas.length - 1].distancia_acumulada_km
                : 0,
            cargaTotalRutaCajas: dayRoute.paradas
                ? dayRoute.paradas.reduce((sum: number, p: any) => sum + (p.cajasAEntregar || 0), 0)
                : 0,
            paradas: dayRoute.paradas ? dayRoute.paradas.map((parada: any, index: number) => ({
                secuenciaParada: index + 1,
                tipoParada: parada.tipoParada || 'ENTREGA',
                nodoId: parada.nodoId,
                nombreSucursal: parada.nombreSucursal,
                branchId: null,
                coordenadas: parada.coordenadas_lat_lon || parada.coordenadas,
                horaLlegada: parada.horaLlegada || 'N/A',
                horaSalida: parada.horaSalida || null,
                ventanaTiempo: parada.ventanaTiempo || null,
                cajasAEntregar: parada.cajasAEntregar || 0
            })) : []
        };

        this.setState({
            showRouteDetailsModal: true,
            selectedRouteForDetails: convertedRoute
        });
    };

    closeRouteDetailsModal = () => {
        this.setState({
            showRouteDetailsModal: false,
            selectedRouteForDetails: null
        });
    };

    handleViewRouteOnMap = () => {
        if (this.state.selectedRouteForDetails && this.state.selectedRouteForDetails.vehiculoId) {
            this.setState({
                selectedVehicles: [this.state.selectedRouteForDetails.vehiculoId],
                showRoutesOnMap: true,
                showRouteDetailsModal: false,
                selectedRouteForDetails: null
            });
        }
    };

    toggleExcludedNodesExpanded = () => {
        this.setState(prevState => ({ excludedNodesExpanded: !prevState.excludedNodesExpanded }));
    };

    handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.setState({ selectedTab: newValue });
    };

    handleFormSubmitFromSystem = async () => {
        // Crear el JSON para el enfoque "desde sistema"
        const selectedBranchesData = this.state.data.branchList && this.state.data.branchList.filter(branch =>
            this.state.selectedBranches.includes(branch.id)
        ) || [];

        const selectedDriversData = this.state.data.drivers && this.state.data.drivers.filter(driver =>
            this.state.selectedDrivers.includes(driver.id)
        ) || [];

        if (selectedBranchesData.length === 0 || selectedDriversData.length === 0) {
            this.props.notification.notification.addWarning('Por favor seleccione al menos una sucursal y un conductor');
            return;
        }

        const jsonData = {
            depot_index: this.state.depotIndex,
            service_time: this.state.serviceTime || 10,
            demand_unit: this.state.demandUnit,
            capacity_unit: this.state.capacityUnit,
            box_volume_m3: this.state.boxVolumeM3,
            locations: selectedBranchesData.map((branch, index) => ({
                suc_nom: branch.name,
                suc_lon: branch.location.lng,
                suc_lat: branch.location.lat,
                inicio_ventana: "08:00:00", // Valor por defecto
                fin_ventana: "18:00:00", // Valor por defecto
                demanda: index === this.state.depotIndex ? 0 : (this.state.branchDemands[branch.id] || 10) // Origen tiene demanda 0
            })),
            fleet: selectedDriversData.map((driver, index) => ({
                matricula: driver.user.name, // Usamos el nombre como matrícula
                capacidad: this.state.driverCapacities[driver.id] || 50, // Usar capacidad personalizada o valor por defecto
                driver_id: driver.id // Agregamos el ID del driver para mapeo posterior
            }))
        };



        this.setState({ isUploading: true });

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("accept", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(jsonData),
            };

            const response = await fetch("/optimize/json-to-json/", requestOptions);

            if (!response.ok) {
                if (response.status === 500) {
                    // Limpiar toda la data relacionada con rutas para error 500
                    this.setState({
                        routesData: [],
                        excludedNodes: [],
                        excludedNodesExpanded: false,
                        showRoutesOnMap: false,
                        selectedRouteId: null,
                        routeDirections: {}
                    });
                    throw new Error('Error interno del servidor (500). Se ha limpiado la información de rutas. Por favor, revise los datos enviados e intente nuevamente.');
                } else {
                    throw new Error(`Error en la petición: ${response.status} ${response.statusText}`);
                }
            }

            const result = await response.json();

            // Procesar la respuesta y transformar al formato esperado
            if (result.routes && Array.isArray(result.routes)) {
                const transformedRoutes = result.routes.map((route: any) => ({
                    vehiculoId: route.vehiculo_id,
                    matricula: route.matricula,
                    driverId: route.matricula ? this.getDriverIdByMatricula(route.matricula) : null,
                    tiempoTotalRutaHhmm: route.tiempoTotalRutaHhmm,
                    kilometrajeTotalRutaKm: route.distanciaTotalRutaKm,
                    cargaTotalRutaCajas: route.cargaTotalRutaCajas,
                    paradas: route.paradas.map((parada: any) => ({
                        secuenciaParada: parada.secuenciaParada,
                        tipoParada: parada.tipoParada,
                        nodoId: parada.nodoId,
                        nombreSucursal: parada.nombreSucursal,
                        branchId: this.getBranchIdByName(parada.nombreSucursal), // ID de sucursal registrada
                        coordenadas: parada.coordenadas,
                        horaLlegada: parada.horaLlegada,
                        horaSalida: parada.horaSalida || null,
                        ventanaTiempo: parada.ventanaTiempo || null,
                        cajasAEntregar: parada.cajasAEntregar
                    }))
                }));

                // Actualizar el estado con las rutas optimizadas y nodos excluidos
                this.setState({
                    routesData: transformedRoutes,
                    excludedNodes: result.excluded_nodes || [],
                    excludedNodesExpanded: false,
                    showRoutesOnMap: true,
                    selectedRouteId: null  // Mostrar todas las rutas por defecto
                });

                this.props.notification.notification.addSuccess(`¡Optimización completada desde el sistema! Se generaron ${transformedRoutes.length} rutas optimizadas.`);
            } else {
                this.props.notification.notification.addError('La respuesta del servidor no tiene el formato esperado.');
            }

        } catch (error) {
            console.error('=== ERROR EN LA PETICIÓN (DESDE SISTEMA) ===');
            console.error('Error:', error);
            this.props.notification.notification.addError(error.message || error);
        } finally {
            this.setState({ isUploading: false });
        }
    };

    handleGenerateNewPlanification = () => {
        const excludedNodes = this.state.excludedNodes;
        // const clientLocations = this.state.data.clientLocations || [];

        console.log('Generando CSV de nodos excluidos:', excludedNodes);

        // Función para escapar campos CSV correctamente
        const escapeCSVField = (field: any) => {
            if (field === null || field === undefined) { return '' };
            const stringField = String(field);
            // Si contiene comas, comillas o saltos de línea, envolver en comillas y escapar comillas internas
            if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                return '"' + stringField.replace(/"/g, '""') + '"';
            }
            return stringField;
        };

        // Map excluded nodes with coordinates
        const csvData = excludedNodes.map((node: any) => {
            // const location = clientLocations.find((loc: any) => loc.id === node.nodoId);
            return {
                suc_nom: node.nombreSucursal || '',
                suc_lon: node.Coordenadas ? node.Coordenadas[0] : null,
                suc_lat: node.Coordenadas ? node.Coordenadas[1] : null,
                ventana_tiempo: `${node.inicioVentana || '06:00:00'}, ${node.finVentana || '22:00:00'}`,
                demanda: node.cajasAEntregar || 0
            };
        });

        // Create CSV content
        const headers = '"suc_nom","suc_lon","suc_lat","ventana_tiempo","demanda"';

        // Fila estática solicitada que debe ir inmediatamente después del encabezado
        // CENTRAL ACCESO SUR ÑEMBY,-57.5533906,-25.3796875,"00:00:00, 23:59:59",0
        const staticRow = 'CENTRAL ACCESO SUR ÑEMBY,-57.5533906,-25.3796875,"00:00:00, 23:59:59",0';

        const rows = csvData.map(row =>
            `${escapeCSVField(row.suc_nom)},${escapeCSVField(row.suc_lon)},${escapeCSVField(row.suc_lat)},${escapeCSVField(row.ventana_tiempo)},${escapeCSVField(row.demanda)}`
        );

        // Insertar la fila estática como la primera fila de datos (después del encabezado)
        const csvContent = [headers, staticRow, ...rows].join('\n');

        // Download CSV
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `nodos_excluidos-${new Date().toLocaleString()}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    handleHorarioInicioJornadaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ horarioInicioJornada: event.target.value });
    };
    handleDailyWorkMinutesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ dailyWorkMinutes: Number(event.target.value) });
    }
    handleWorkTimeToleranceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ workTimeToleranceMinutes: Number(event.target.value) });
    }
    handleMaxDiasConsecutivosChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ maxDiasConsecutivos: Number(event.target.value) });
    }

    handleDiaLaboralChange = (dia: string) => {
        this.setState(prevState => ({
            diasLaborales: {
                ...prevState.diasLaborales,
                [dia]: !prevState.diasLaborales[dia as keyof typeof prevState.diasLaborales]
            }
        }));
    };

    handleMinTravelTimeForRestChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ min_travel_time_for_rest_minutes: Number(event.target.value) });
    };

    render() {
        const defaultLocation = {
            id: 0, lat: 0, lng: 0, street1: '',
            client: {
                user: { name: '', email: '' },
                phone: ''

            }
        };
        let clientLocations: LocationData[] = [defaultLocation];

        if (this.state.data.clientLocations && this.state.data.clientLocations.length > 0) {
            clientLocations = this.state.data.clientLocations;
            const newLocation = {
                id: 0, lat: 0, lng: 0, street1: '',
                client: {
                    user: {
                        name: clientLocations[0].client.user.name,
                        email: clientLocations[0].client.user.email
                    },
                    phone: clientLocations[0].client.phone
                }
            };
            clientLocations.push(newLocation);

        }


        return (<div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
            {/* Tab Navigation */}
            <Grid container direction="row" style={{ marginBottom: '20px' }}>
                <Grid item md={12}>
                    <Tabs
                        value={this.state.selectedTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Procesar por CSV" />
                    </Tabs>
                </Grid>
            </Grid>

            {/* CSV Upload Form - Tab 0 */}
            {this.state.selectedTab === 0 && (
                <Grid container direction="row" style={{ marginBottom: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Grid item md={12}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <Typography component="h6">
                                Cargar Datos de Planificación por CSV
                            </Typography>
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={this.handleReset}
                            >
                                🗑️ Limpiar
                            </Button>
                        </div>
                        <form onSubmit={this.handleFormSubmit} encType="multipart/form-data">
                            <Grid container>
                                <Grid item md={2} style={{ paddingRight: '15px' }}>
                                    <TextField
                                        fullWidth
                                        label="Sucursal Origen (Depot Index)"
                                        type="number"
                                        value={this.state.depotIndex}
                                        onChange={this.handleDepotIndexChange}
                                        required
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField
                                        fullWidth
                                        label="Tiempo por Sucursal (minutos)"
                                        type="number"
                                        value={this.state.serviceTime ? this.state.serviceTime : 10}
                                        onChange={this.handleServiceTimeChange}
                                        required
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField
                                        fullWidth
                                        label="Horario de inicio de jornada"
                                        value={this.state.horarioInicioJornada ? this.state.horarioInicioJornada : ""}
                                        onChange={this.handleHorarioInicioJornadaChange}
                                        required
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField
                                        fullWidth
                                        label="Tiempo de trabajo por día (minutos)"
                                        value={this.state.dailyWorkMinutes ? this.state.dailyWorkMinutes : 480}
                                        onChange={this.handleDailyWorkMinutesChange}
                                        margin="normal"
                                        type="number"
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField
                                        fullWidth
                                        label="Horas extra de trabajo (minutos)"
                                        value={this.state.workTimeToleranceMinutes ? this.state.workTimeToleranceMinutes : 120}
                                        onChange={this.handleWorkTimeToleranceChange}
                                        margin="normal"
                                        type="number"
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField
                                        fullWidth
                                        label="Tiempo mínimo de viaje para descanso (minutos)"
                                        value={this.state.min_travel_time_for_rest_minutes ? this.state.min_travel_time_for_rest_minutes : 120}
                                        onChange={this.handleMinTravelTimeForRestChange}
                                        margin="normal"
                                        type="number"
                                    />
                                </Grid>


                                
                            </Grid>
                            
                            {/* Días Laborales Selection */}
                            <Grid container spacing={16} style={{ marginTop: '10px' }}>
                                <Grid item xs={12}>
                                    <Typography style={{ marginBottom: '16px', fontSize: '20px', fontWeight: 500 }}>
                                        Días Laborales
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
                                        {['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'].map((dia: any) => (
                                            <div key={dia} style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    id={`dia-${dia}`}
                                                    checked={(this.state.diasLaborales as any)[dia]}
                                                    onChange={() => this.handleDiaLaboralChange(dia)}
                                                    style={{ marginRight: '8px', cursor: 'pointer' }}
                                                />
                                                <label
                                                    htmlFor={`dia-${dia}`}
                                                    style={{
                                                        cursor: 'pointer',
                                                        textTransform: 'capitalize',
                                                        fontSize: '14px'
                                                    }}
                                                >
                                                    {dia.charAt(0).toUpperCase() + dia.slice(1)}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={16} style={{ marginTop: '10px' }}>
                                <Grid item md={3}>
                                    <Typography style={{ marginTop: '16px', marginBottom: '8px' }}>
                                        Unidad de Demanda
                                    </Typography>
                                    <Select
                                        fullWidth
                                        value={this.state.demandUnit}
                                        onChange={this.handleDemandUnitChange}
                                        displayEmpty
                                        style={{ marginTop: '8px' }}
                                    >
                                        <MenuItem value="cajas">Cajas</MenuItem>
                                        <MenuItem value="volumen">Volumen</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item md={3}>
                                    <Typography style={{ marginTop: '16px', marginBottom: '8px' }}>
                                        Unidad de Capacidad
                                    </Typography>
                                    <Select
                                        fullWidth
                                        value={this.state.capacityUnit}
                                        onChange={this.handleCapacityUnitChange}
                                        displayEmpty
                                        style={{ marginTop: '8px' }}
                                    >
                                        <MenuItem value="cajas">Cajas</MenuItem>
                                        <MenuItem value="volumen">Volumen</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        fullWidth
                                        label="Volumen por Caja (m³) *"
                                        type="number"
                                        value={this.state.boxVolumeM3.toString()}
                                        onChange={this.handleBoxVolumeChange}
                                        required
                                        margin="normal"
                                        inputProps={{ step: "0.001", min: "0.001" }}
                                        helperText="Campo obligatorio para distribución de vehículos"
                                        error={this.state.boxVolumeM3 <= 0}
                                    />
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        fullWidth
                                        label="Fecha de Inicio de Planificación *"
                                        type="date"
                                        value={this.state.planningStartDate}
                                        onChange={(e) => this.setState({ planningStartDate: e.target.value })}
                                        required
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        helperText="Fecha de inicio de la planificación"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={16} style={{ marginTop: '10px' }}>
                                <Grid item md={6} style={{ paddingRight: '15px' }}>
                                    <div style={{ marginTop: '16px' }}>
                                        <input
                                            name="csv-locations-file-upload"
                                            accept=".csv"
                                            style={{ display: 'none' }}
                                            id="csv-locations-file-upload"
                                            type="file"
                                            onChange={this.handleLocationsFileChange}
                                        />
                                        <label htmlFor="csv-locations-file-upload">
                                            <Button
                                                variant="contained"
                                                component="span"
                                                fullWidth
                                                style={{ height: '56px' }}
                                            >
                                                {this.state.csvLocationsFile ? this.state.csvLocationsFile.name : 'Seleccionar archivo CSV de Ubicaciones'}
                                            </Button>
                                        </label>
                                    </div>
                                </Grid>
                                <Grid item md={6}>
                                    <div style={{ marginTop: '16px' }}>
                                        <input
                                            name="csv-fleet-file-upload"
                                            accept=".csv"
                                            style={{ display: 'none' }}
                                            id="csv-fleet-file-upload"
                                            type="file"
                                            onChange={this.handleDriversFileChange}
                                        />
                                        <label htmlFor="csv-fleet-file-upload">
                                            <Button
                                                variant="contained"
                                                component="span"
                                                fullWidth
                                                style={{ height: '56px' }}
                                            >
                                                {this.state.csvDriversFile ? this.state.csvDriversFile.name : 'Seleccionar archivo CSV de Flota'}
                                            </Button>
                                        </label>
                                    </div>
                                </Grid>
                                {/* Tarjeta informativa de demanda vs capacidad */}
                                {(this.state.locationsCSVLoaded || this.state.fleetCSVLoaded) && (
                                    <Grid item md={12} style={{ marginTop: '20px' }}>
                                        <div style={{
                                            padding: '20px',
                                            borderRadius: '8px',
                                            backgroundColor: this.state.totalCapacityFromFleetCSV >= this.state.totalDemandFromLocationsCSV ? '#e8f5e9' : '#fff3e0',
                                            border: `2px solid ${this.state.totalCapacityFromFleetCSV >= this.state.totalDemandFromLocationsCSV ? '#4caf50' : '#ff9800'}`,
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                        }}>
                                            <Typography style={{
                                                fontWeight: 'bold',
                                                color: this.state.totalCapacityFromFleetCSV >= this.state.totalDemandFromLocationsCSV ? '#2e7d32' : '#e65100',
                                                marginBottom: '12px'
                                            }}>
                                                📊 Resumen de Capacidad vs Demanda
                                            </Typography>
                                            <Grid container spacing={16}>
                                                <Grid item md={6}>
                                                    <Typography variant="body2" style={{ color: '#555', marginBottom: '4px' }}>
                                                        <strong>📦 Demanda Total (Cajas):</strong>
                                                    </Typography>
                                                    <Typography style={{
                                                        color: '#d32f2f',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {this.state.totalDemandFromLocationsCSV.toLocaleString()}
                                                    </Typography>
                                                </Grid>
                                                <Grid item md={6}>
                                                    <Typography variant="body2" style={{ color: '#555', marginBottom: '4px' }}>
                                                        <strong>🚛 Capacidad Total:</strong>
                                                    </Typography>
                                                    <Typography style={{
                                                        color: '#1976d2',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {(this.state.totalCapacityFromFleetCSV).toLocaleString()}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                                                <Typography variant="body2" style={{
                                                    fontWeight: 'bold',
                                                    color: this.state.totalCapacityFromFleetCSV >= this.state.totalDemandFromLocationsCSV ? '#2e7d32' : '#e65100'
                                                }}>
                                                    {this.state.totalCapacityFromFleetCSV >= this.state.totalDemandFromLocationsCSV ? (
                                                        <>
                                                            ✅ Capacidad SUFICIENTE
                                                        </>
                                                    ) : (
                                                        <>
                                                            ⚠️ CAPACIDAD INSUFICIENTE - Déficit: {(this.state.totalDemandFromLocationsCSV - this.state.totalCapacityFromFleetCSV).toLocaleString()} cajas
                                                        </>
                                                    )}
                                                </Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                )}
                                <Grid item md={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={this.state.isUploading || !this.isCSVFormValid()}
                                        fullWidth
                                        style={{ marginTop: '10px' }}
                                    >
                                        {this.state.isUploading ? (
                                            <>
                                                <CircularProgress size={20} style={{ marginRight: '10px' }} />
                                                Procesando CSV...
                                            </>
                                        ) : !this.isCSVFormValid() ? (
                                            'Complete todos los campos obligatorios'
                                        ) : (
                                            'Procesar Archivos CSV'
                                        )}
                                    </Button>
                                </Grid>

                                {/* Progress indicator for branch creation */}
                                {this.state.isCreatingBranches && (
                                    <Grid item md={12} style={{ marginTop: '20px' }}>
                                        <Typography variant="body2" style={{ marginBottom: '8px', textAlign: 'center' }}>
                                            Registrando sucursales desde CSV...
                                        </Typography>
                                        <LinearProgress
                                            variant="determinate"
                                            value={this.state.branchesCreationProgress}
                                            style={{ height: '8px', borderRadius: '4px' }}
                                        />
                                        <Typography variant="caption" style={{ marginTop: '4px', textAlign: 'center', display: 'block' }}>
                                            Lote {this.state.currentBatch} de {this.state.totalBatches} - {Math.round(this.state.branchesCreationProgress)}% completado
                                        </Typography>
                                        <Typography variant="caption" style={{ marginTop: '2px', textAlign: 'center', display: 'block' }}>
                                            {this.state.branchesCreated} de {this.state.totalBranchesToCreate} sucursales registradas
                                        </Typography>
                                        {this.props.onCancelBranchCreation && (
                                            <Grid container justify="center" style={{ marginTop: '10px' }}>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    size="small"
                                                    onClick={this.props.onCancelBranchCreation}
                                                    disabled={this.state.isCancellingBranches}
                                                >
                                                    {this.state.isCancellingBranches ? 'Cancelando...' : 'Cancelar Proceso'}
                                                </Button>
                                            </Grid>
                                        )}
                                    </Grid>
                                )}

                                {/* Progress indicator for driver creation */}
                                {this.state.isCreatingDrivers && (
                                    <Grid item md={12} style={{ marginTop: '20px' }}>
                                        <Typography variant="body2" style={{ marginBottom: '8px', textAlign: 'center' }}>
                                            Registrando choferes desde CSV...
                                        </Typography>
                                        <LinearProgress
                                            variant="determinate"
                                            value={(this.state.driversCreated / this.state.totalDriversToCreate) * 100}
                                            style={{ height: '8px', borderRadius: '4px' }}
                                        />
                                        <Typography variant="caption" style={{ marginTop: '4px', textAlign: 'center', display: 'block' }}>
                                            Lote {this.state.currentDriverBatch} de {this.state.totalDriverBatches} - {Math.round((this.state.driversCreated / this.state.totalDriversToCreate) * 100)}% completado
                                        </Typography>
                                        <Typography variant="caption" style={{ marginTop: '2px', textAlign: 'center', display: 'block' }}>
                                            {this.state.driversCreated} de {this.state.totalDriversToCreate} choferes registrados
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            )}

            {/* Excluded Nodes Panel */}
            {this.state.excludedNodes && this.state.excludedNodes.length > 0 && (
                <Grid container direction="row" style={{ marginBottom: '20px', padding: '20px', border: '2px solid #f44336', borderRadius: '8px', backgroundColor: '#ffebee' }}>
                    <Grid item md={12}>
                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={this.toggleExcludedNodesExpanded}>
                            <Typography component="h6" style={{ marginBottom: '0', color: '#d32f2f', fontWeight: 'bold', flexGrow: 1 }}>
                                🚫 Nodos Excluidos ({this.state.excludedNodes.length}) <Button
                                    onClick={this.handleGenerateNewPlanification}
                                    style={{ marginLeft: '10px', padding: '4px 8px', fontSize: '12px' }}
                                    variant="outlined"
                                    color="primary"
                                >
                                    Exportar a CSV
                                </Button>
                            </Typography>
                            <IconButton style={{ color: '#d32f2f' }}>
                                {this.state.excludedNodesExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </div>
                        {this.state.excludedNodesExpanded && (
                            <Grid container spacing={16} style={{ marginTop: '15px' }}>
                                {this.state.excludedNodes.map((node: any, index: number) => (
                                    <Grid item md={6} key={index}>
                                        <div style={{ padding: '15px', border: '1px solid #ffcdd2', borderRadius: '4px', backgroundColor: 'white' }}>
                                            <Typography style={{ fontWeight: 'bold', color: '#d32f2f' }}>
                                                {node.nombreSucursal} (ID: {node.nodoId})
                                            </Typography>
                                            <Typography style={{ marginTop: '5px', color: '#666' }}>
                                                <strong>Motivo:</strong> {node.Motivo_Exclusion}
                                            </Typography>
                                            <Typography style={{ color: '#666' }}>
                                                <strong>Cajas:</strong> {node.cajasAEntregar} | <strong>Volumen:</strong> {node.volumenAEntregarM3}m³
                                            </Typography>
                                            <Typography style={{ color: '#666' }}>
                                                <strong>Ventana:</strong> {node.ventanaTiempo}
                                            </Typography>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            )}

            {/* Mostrar mapa solo cuando hay rutas optimizadas multiday */}
            {this.state.multidayRoutesData && (
                <React.Fragment>
                    {/* Statistics Panel - Solo MULTIDAY */}
                    <Grid container spacing={16} style={{
                        marginBottom: '20px',
                        padding: '20px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
                    }}>
                        {/* Vehículos Utilizados */}
                        <Grid item xs={12} sm={6} md={4}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '1px solid rgba(255, 255, 255, 0.18)',
                                textAlign: 'center'
                            }}>
                                <Typography style={{ color: '#fff', marginBottom: '10px', fontWeight: 300, fontSize: '14px' }}>
                                    🚚 Vehículos Utilizados
                                </Typography>
                                <Typography style={{ color: '#fff', fontWeight: 700, fontSize: '32px' }}>
                                    {this.state.multidayRoutesData.resumen.total_vehiculos_utilizados || 0}
                                </Typography>
                            </div>
                        </Grid>

                        {/* Total Sucursales */}
                        <Grid item xs={12} sm={6} md={4}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '1px solid rgba(255, 255, 255, 0.18)',
                                textAlign: 'center'
                            }}>
                                <Typography style={{ color: '#fff', marginBottom: '10px', fontWeight: 300, fontSize: '14px' }}>
                                    📍 Total Sucursales
                                </Typography>
                                <Typography style={{ color: '#fff', fontWeight: 700, fontSize: '32px' }}>
                                    {this.state.multidayRoutesData.resumen.total_sucursales || 0}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#fff', marginTop: '5px', fontWeight: 400, fontSize: '12px' }}>
                                    ✅ Servidos: {this.state.multidayRoutesData.resumen.total_servidos || 0} | ❌ Excluidos: {this.state.multidayRoutesData.resumen.total_excluidos || 0}
                                </Typography>
                            </div>
                        </Grid>

                        {/* Total Cajas */}
                        <Grid item xs={12} sm={6} md={4}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '1px solid rgba(255, 255, 255, 0.18)',
                                textAlign: 'center'
                            }}>
                                <Typography style={{ color: '#fff', marginBottom: '10px', fontWeight: 300, fontSize: '14px' }}>
                                    📦 Total Cajas
                                </Typography>
                                <Typography style={{ color: '#fff', fontWeight: 700, fontSize: '32px' }}>
                                    {(this.state.multidayRoutesData.resumen.cargaTotalPlanificacionCajas || 0).toLocaleString('es-PY')}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#fff', marginTop: '5px', fontWeight: 400, fontSize: '12px' }}>
                                    Volumen: {(this.state.multidayRoutesData.resumen.cargaTotalPlanificacionVolumenM3 || 0).toFixed(2)} m³
                                </Typography>
                            </div>
                        </Grid>

                        {/* Total Kilómetros - Destacado */}
                        <Grid item xs={12} sm={12} md={12}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '20px',
                                border: '3px solid #FFD700',
                                textAlign: 'center',
                                boxShadow: '0 0 20px rgba(255, 215, 0, 0.5)',
                                transform: 'scale(1.02)'
                            }}>
                                <Typography style={{ color: '#667eea', marginBottom: '10px', fontWeight: 600, fontSize: '18px' }}>
                                    📏 Distancia Total Planificación
                                </Typography>
                                <Typography style={{ color: '#764ba2', fontWeight: 800, fontSize: '48px' }}>
                                    {(this.state.multidayRoutesData.resumen.distanciaTotalPlanificacionKm || 0).toLocaleString('es-PY', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </Typography>
                                <Typography variant="body2" style={{ color: '#667eea', marginTop: '5px', fontWeight: 500, fontSize: '16px' }}>
                                    kilómetros
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>


                    {/* Controles de visualización del mapa */}
                    <Grid container direction="row" style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                        <Grid item md={12}>
                            <Typography style={{ marginBottom: '10px' }}>
                                ⚠️ <strong>Optimización del Mapa</strong>
                            </Typography>
                            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <Button
                                    variant={this.state.showMarkersOnly ? "contained" : "outlined"}
                                    color="primary"
                                    size="small"
                                    onClick={this.toggleMarkersOnly}
                                >
                                    {this.state.showMarkersOnly ? '📍 Solo Marcadores (Rápido)' : '🗺️ Ver Rutas Completas'}
                                </Button>

                                <Typography variant="caption" color="textSecondary">
                                    💡 Tip: Use "Solo Marcadores" para mejor rendimiento con muchas rutas
                                </Typography>
                            </div>

                            {/* Controles para rutas multiday */}
                            {this.state.multidayRoutesData && (
                                <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                                    <Typography variant="body1" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                                        🗓️ Planificación Multi-Día
                                    </Typography>
                                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        {/* Selector de día */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography variant="caption">Filtrar por día:</Typography>
                                            <Select
                                                value={this.state.selectedDay === null ? 'all' : this.state.selectedDay}
                                                onChange={this.handleDayChange}
                                                style={{ minWidth: '150px', height: '36px' }}
                                            >
                                                <MenuItem value="all">Todos los días</MenuItem>
                                                {this.state.availableDays.map(day => (
                                                    <MenuItem key={day} value={day}>Día {day}</MenuItem>
                                                ))}
                                            </Select>
                                        </div>

                                        {/* Información de configuración */}
                                        <Typography variant="caption" color="textSecondary">
                                            📦 {this.state.multidayRoutesData.rutas.length} vehículos |
                                            📅 {this.state.availableDays.length} días |
                                            ⏰ {this.state.multidayRoutesData.configuracion.hora_inicio_jornada_HH_mm} inicio
                                        </Typography>

                                        {/* Lista de vehículos con checkbox */}
                                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
                                            {/* Botón para seleccionar todos los vehículos */}
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                style={{ minWidth: '140px', fontWeight: 'bold' }}
                                                onClick={this.handleSelectAllVehicles}
                                            >
                                                ✅ Seleccionar Todos
                                            </Button>

                                            {this.state.multidayRoutesData.rutas.map(vehicleRoute => {
                                                const isSelected = this.state.selectedVehicles.includes(vehicleRoute.vehiculo_id);
                                                const color = this.getVehicleColor(vehicleRoute.vehiculo_id);
                                                return (
                                                    <Button
                                                        key={vehicleRoute.vehiculo_id}
                                                        variant={isSelected ? "contained" : "outlined"}
                                                        size="small"
                                                        style={{
                                                            backgroundColor: isSelected ? color : 'transparent',
                                                            color: isSelected ? '#fff' : '#000',
                                                            borderColor: color,
                                                            minWidth: '120px'
                                                        }}
                                                        onClick={() => this.handleVehicleSelection(vehicleRoute.vehiculo_id)}
                                                    >
                                                        🚚 {vehicleRoute.matricula}
                                                    </Button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Grid>
                    </Grid>

                    <div style={{ position: 'relative', height: '400px', marginBottom: '20px' }}>
                        <EnhancedMap
                            center={this.state.center}
                            zoom={this.props.config.maps.startingLocation.zoom}
                            destiny={
                                this.state.data.visitsDetail &&
                                    this.state.data.visitsDetail.length > 0
                                    ? this.state.data.visitsDetail
                                    : this.state.data.destiny
                            }
                            directions={this.state.data.fullData}
                            routesData={this.state.routesData}
                            selectedRouteId={this.state.selectedRouteId}
                            showRoutesOnMap={this.state.showRoutesOnMap && !this.state.showMarkersOnly}
                            routeDirections={this.state.routeDirections}
                            onRouteDirectionsChange={(newRouteDirections) => this.setState({ routeDirections: newRouteDirections })}
                            maxVisibleRoutes={999}
                            showMarkersOnly={this.state.showMarkersOnly}
                            multidayRoutesData={this.state.multidayRoutesData}
                            selectedDay={this.state.selectedDay}
                            selectedVehicles={this.state.selectedVehicles}
                        ></EnhancedMap>

                        {/* Alerta de demasiadas paradas - RENDERIZADO COMO OVERLAY ABSOLUTO */}
                        {this.state.multidayRoutesData && this.state.showTooManyStopsAlert && (() => {
                            let totalStops = 0;
                            if (this.state.multidayRoutesData.rutas) {
                                totalStops = this.state.multidayRoutesData.rutas.reduce((total, vehicleRoute) => {
                                    if (this.state.selectedVehicles && this.state.selectedVehicles.length > 0 && !this.state.selectedVehicles.includes(vehicleRoute.vehiculo_id)) {
                                        return total;
                                    }
                                    if (vehicleRoute.dias) {
                                        return total + vehicleRoute.dias.reduce((dayTotal, dayRoute) => {
                                            if (this.state.selectedDay && dayRoute.dia !== this.state.selectedDay) {
                                                return dayTotal;
                                            }
                                            const paradasLength = dayRoute.paradas ? dayRoute.paradas.length : 0;
                                            return dayTotal + paradasLength;
                                        }, 0);
                                    }
                                    return total;
                                }, 0);
                            }

                            return totalStops > 1000 && (
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    background: 'rgba(255, 255, 255, 0.99)',
                                    padding: '30px',
                                    borderRadius: '12px',
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
                                    maxWidth: '450px',
                                    textAlign: 'center',
                                    zIndex: 1001,
                                    border: '2px solid #ff9800'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                                        <Typography color="error" style={{ margin: 0, flex: 1, fontSize: '18px', fontWeight: 'bold' }}>
                                            ⚠️ Demasiadas paradas para mostrar
                                        </Typography>
                                        <button
                                            onClick={this.handleCloseTooManyStopsAlert}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                fontSize: '28px',
                                                cursor: 'pointer',
                                                padding: '0',
                                                marginLeft: '15px',
                                                color: '#999',
                                                lineHeight: '1'
                                            }}
                                            title="Cerrar alerta"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                    <Typography variant="body2" style={{ marginBottom: '15px' }}>
                                        Total de paradas: <strong style={{ fontSize: '18px', color: '#d32f2f' }}>{totalStops}</strong>
                                    </Typography>
                                    <Typography variant="body2" style={{ marginBottom: '15px', lineHeight: '1.6' }}>
                                        Para evitar el colapso del navegador, filtra por día específico o selecciona menos vehículos.
                                    </Typography>
                                    <Typography variant="caption" style={{ display: 'block', color: '#666', fontSize: '12px' }}>
                                        Límite máximo: 1000 paradas | Límite para mostrar rutas: 500 paradas
                                    </Typography>
                                </div>
                            );
                        })()}
                    </div>

                    <Grid container direction="row">
                        <Grid item md={12}>
                            <hr />
                            <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }}>
                                <h6>Rutas Disponibles</h6>
                            </Grid>

                            <div style={{ width: '100%' }}>
                                {/* Tabla para rutas multiday */}
                                {this.state.multidayRoutesData ? (
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-around', backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
                                            <div style={{ width: '10%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Vehículo</label></div>
                                            <div style={{ width: '8%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Día</label></div>
                                            <div style={{ width: '10%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Tiempo</label></div>
                                            <div style={{ width: '10%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Distancia</label></div>
                                            <div style={{ width: '10%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Carga</label></div>
                                            <div style={{ width: '8%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Paradas</label></div>
                                            <div style={{ width: '12%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Origen</label></div>
                                            <div style={{ width: '12%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Destino</label></div>
                                            <div style={{ width: '10%' }}><label style={{ fontSize: '13px', fontWeight: 'bold' }}>Acción</label></div>
                                        </div>
                                        <div>
                                            {this.state.multidayRoutesData.rutas.map((vehicleRoute) => {
                                                // Filtrar por vehículos seleccionados
                                                if (this.state.selectedVehicles.length > 0 && !this.state.selectedVehicles.includes(vehicleRoute.vehiculo_id)) {
                                                    return null;
                                                }

                                                return vehicleRoute.dias.map((dayRoute) => {
                                                    // Filtrar por día seleccionado
                                                    if (this.state.selectedDay !== null && dayRoute.dia !== this.state.selectedDay) {
                                                        return null;
                                                    }

                                                    const color = this.getVehicleColor(vehicleRoute.vehiculo_id);

                                                    return (
                                                        <div
                                                            key={`${vehicleRoute.vehiculo_id}-day-${dayRoute.dia}`}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-around',
                                                                fontSize: '11px',
                                                                border: `2px solid ${color}`,
                                                                borderRadius: '5px',
                                                                padding: '8px',
                                                                marginBottom: '8px',
                                                                backgroundColor: '#fff'
                                                            }}
                                                        >
                                                            <div style={{ width: '10%', marginLeft: '2px', fontWeight: 'bold' }}>
                                                                🚚 {vehicleRoute.matricula}
                                                            </div>
                                                            <div style={{ width: '8%', marginLeft: '2px' }}>
                                                                📅 Día {dayRoute.dia}
                                                            </div>
                                                            <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                ⏱️ {dayRoute.paradas && dayRoute.paradas.length > 0
                                                                    ? `${Math.floor(dayRoute.paradas[dayRoute.paradas.length - 1].tiempo_acumulado_dia_min / 60)}h ${dayRoute.paradas[dayRoute.paradas.length - 1].tiempo_acumulado_dia_min % 60}m`
                                                                    : 'N/A'}
                                                            </div>
                                                            <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                📏 {dayRoute.paradas && dayRoute.paradas.length > 0
                                                                    ? `${dayRoute.paradas[dayRoute.paradas.length - 1].distancia_acumulada_km.toFixed(2)} km`
                                                                    : 'N/A'}
                                                            </div>
                                                            <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                📦 {dayRoute.paradas
                                                                    ? dayRoute.paradas.reduce((sum, p) => sum + (p.cajasAEntregar || 0), 0)
                                                                    : 0} cajas
                                                            </div>
                                                            <div style={{ width: '8%', marginLeft: '2px' }}>
                                                                📍 {dayRoute.paradas ? dayRoute.paradas.length : 0} paradas
                                                            </div>
                                                            <div style={{ width: '12%', marginLeft: '2px', fontSize: '10px' }}>
                                                                {dayRoute.paradas && dayRoute.paradas.length > 0 ? dayRoute.paradas[0].nombreSucursal : 'N/A'}
                                                            </div>
                                                            <div style={{ width: '12%', marginLeft: '2px', fontSize: '10px' }}>
                                                                {dayRoute.paradas && dayRoute.paradas.length > 0 ? dayRoute.paradas[dayRoute.paradas.length - 1].nombreSucursal : 'N/A'}
                                                            </div>
                                                            <div style={{ width: '10%', marginLeft: '2px' }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    style={{ fontSize: '10px', padding: '2px 6px' }}
                                                                    onClick={() => this.openMultidayRouteDetailsModal(vehicleRoute, dayRoute)}
                                                                >
                                                                    Ver Detalles
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    );
                                                });
                                            })}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <br />

                            {/* Barra de progreso para creación de carreras */}
                            {this.state.isCreatingRaces && (
                                <div style={{ marginBottom: 16 }}>
                                    <Typography variant="body2" gutterBottom>
                                        Creando planificación: {this.state.racesCreated} de {this.state.totalRacesToCreate}
                                    </Typography>
                                    <LinearProgress
                                        variant="determinate"
                                        value={this.state.racesCreationProgress}
                                        style={{ marginBottom: 8 }}
                                    />
                                </div>
                            )}

                            {/* Spinner para mostrar cuando la barra termina pero Redux sigue procesando */}
                            {!this.state.isCreatingRaces && this.state.racesCreated > 0 && this.state.racesCreated === this.state.totalRacesToCreate && (
                                <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                    <CircularProgress size={24} />
                                    <Typography variant="body2" color="textSecondary">
                                        Procesando planificación en el servidor...
                                    </Typography>
                                </div>
                            )}

                            {/* Mostrar botón guardar solo cuando hay rutas optimizadas */}
                            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.isCreatingRaces}
                                >
                                    {this.state.isCreatingRaces ? 'Creando...' : 'Guardar'}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </React.Fragment>
            )}

            {/* Modal for Route Details */}
            <Dialog
                open={this.state.showRouteDetailsModal}
                onClose={this.closeRouteDetailsModal}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    Detalles de la Ruta {this.state.selectedRouteForDetails && this.state.selectedRouteForDetails.matricula
                        ? `- 🚚 ${this.state.selectedRouteForDetails.matricula}`
                        : this.state.selectedRouteForDetails && this.state.selectedRouteForDetails.vehiculoId
                            ? `- Vehículo ${this.state.selectedRouteForDetails.vehiculoId}`
                            : ''}
                </DialogTitle>
                <DialogContent>
                    {this.state.selectedRouteForDetails && (
                        <div>
                            {/* Vehicle and Driver Information */}
                            <Typography component="h6" style={{ marginBottom: '10px', color: '#1976d2', fontWeight: 'bold' }}>
                                Información del Vehículo y Conductor
                            </Typography>
                            {(() => {
                                const vehicle = this.getVehicleByMatricula((this.state.selectedRouteForDetails as any).matricula);
                                return vehicle ? (
                                    <Grid container style={{ marginBottom: '20px', backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
                                        <Grid item xs={6}>
                                            <Typography><strong>Matrícula:</strong> {(this.state.selectedRouteForDetails as any).matricula || vehicle.placa}</Typography>
                                            <Typography><strong>Marca:</strong> {vehicle.marca}</Typography>
                                            <Typography><strong>Modelo:</strong> {vehicle.modelo}</Typography>
                                            {(this.state.selectedRouteForDetails as any).fechaEstimadaInicio && (() => {
                                                // const fecha = new Date((this.state.selectedRouteForDetails as any).fechaEstimadaInicio);
                                                // const fechaFormato = `${String(fecha.getDate()).padStart(2, '0')}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${fecha.getFullYear()}`;
                                                return <Typography><strong>📅 Fecha Estimada Inicio:</strong> {(this.state.selectedRouteForDetails as any).fechaEstimadaInicio}</Typography>;
                                            })()}
                                        </Grid>
                                        <Grid item xs={6}>
                                            {/* <Typography><strong>Capacidad:</strong> {vehicle.capacidadCajas} cajas</Typography> */}
                                            {vehicle.conductor && (
                                                <>
                                                    <Typography><strong>ID Conductor:</strong> {vehicle.conductor.id}</Typography>
                                                    <Typography><strong>Conductor:</strong> {vehicle.conductor.user.name}</Typography>
                                                </>
                                            )}
                                            {(this.state.selectedRouteForDetails as any).fechaDia && (() => {
                                                // const fecha = new Date((this.state.selectedRouteForDetails as any).fechaDia);
                                                // const fechaFormato = `${String(fecha.getDate()).padStart(2, '0')}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${fecha.getFullYear()}`;
                                                return <Typography><strong>📆 Fecha del Día:</strong> {(this.state.selectedRouteForDetails as any).fechaDia}</Typography>;
                                            })()}
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Typography style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#fff3cd', borderRadius: '4px' }}>
                                        ℹ️ No se encontró información del conductor para este vehículo (Matrícula: {this.state.selectedRouteForDetails.matricula})
                                    </Typography>
                                );
                            })()}

                            {/* Route Summary */}
                            <Typography component="h6" style={{ marginBottom: '10px', color: '#1976d2', fontWeight: 'bold' }}>
                                Resumen de la Ruta
                            </Typography>
                            <Grid container style={{ marginBottom: '20px' }}>
                                <Grid item xs={6}>
                                    <Typography><strong>Tiempo Total:</strong> {this.state.selectedRouteForDetails.tiempoTotalRutaHhmm}</Typography>
                                    <Typography><strong>Distancia Total:</strong> {this.state.selectedRouteForDetails.kilometrajeTotalRutaKm} km</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography><strong>Carga Total:</strong> {this.state.selectedRouteForDetails.cargaTotalRutaCajas} cajas</Typography>
                                    {(this.state.selectedRouteForDetails as any).fechaDia && (() => {
                                        // const fecha = new Date((this.state.selectedRouteForDetails as any).fechaDia);
                                        // const fechaFormato = `${String(fecha.getDate()).padStart(2, '0')}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${fecha.getFullYear()}`;
                                        return <Typography><strong>📆 Fecha Operación:</strong> {(this.state.selectedRouteForDetails as any).fechaDia }</Typography>;
                                    })()}
                                </Grid>
                            </Grid>

                            {/* Stops Details */}
                            <Typography component="h6" style={{ marginBottom: '10px' }}>
                                Detalles de las Paradas
                            </Typography>
                            {this.state.selectedRouteForDetails.paradas && this.state.selectedRouteForDetails.paradas.length > 0 ? (
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    {this.state.selectedRouteForDetails.paradas.map((parada, index) => (
                                        <div key={index} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', marginBottom: '10px' }}>
                                            <Typography style={{ fontWeight: 'bold' }}>
                                                Parada {index + 1}: {parada.nombreSucursal}
                                            </Typography>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <Typography><strong>Tipo:</strong> {parada.tipoParada}</Typography>
                                                    <Typography><strong>Cajas a entregar:</strong> {parada.cajasAEntregar}</Typography>
                                                    <Typography><strong>Hora llegada:</strong> {parada.horaLlegada}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography><strong>Coordenadas:</strong> {parada.coordenadas ? `${parada.coordenadas[0]}, ${parada.coordenadas[1]}` : 'No disponibles'}</Typography>
                                                    <Typography><strong>Secuencia:</strong> {parada.secuenciaParada}</Typography>
                                                    {parada.horaSalida && (
                                                        <Typography><strong>Hora salida:</strong> {parada.horaSalida}</Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            {parada.ventanaTiempo && (
                                                <Typography style={{ marginTop: '8px' }}>
                                                    <strong>Ventana de tiempo:</strong> {parada.ventanaTiempo}
                                                </Typography>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <Typography>No hay paradas disponibles para esta ruta</Typography>
                            )}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeRouteDetailsModal} color="primary">
                        Cerrar
                    </Button>
                    <Button
                        onClick={this.handleViewRouteOnMap}
                        color="secondary"
                        variant="contained"
                    >
                        Ver recorrido en mapa
                    </Button>
                </DialogActions>
            </Dialog>

        </div>);
    }

}


export default compose<any, PlanificacionSelectorProps>(withProps((props: PlanificacionSelectorProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(PlanificacionMultiSelector);



// WEBPACK FOOTER //
// ./src/components/planificacion-multiday/planificacionMultiSelector.tsx